import withRouter from "components/Common/withRouter";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useCallback ,useMemo} from "react";
import ToastDialog from "components/Common/ToastDialog";
import { FieldArray, FormikProvider, useFormik } from "formik";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import { API_URL } from "../../http/url.helper";
import Loader from "react-spinner-loader";
import Breadcrumbs from "components/Common/BreadcrumbTitle";
import { formatDistanceToNow } from "date-fns";
import { parse, format } from 'date-fns';
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Label,
  Row,
  Input,
  FormFeedback,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  UncontrolledAlert,
  ModalHeader,
  Modal,
  Table,
  UncontrolledTooltip,
} from "reactstrap";
import * as Yup from "yup";
import classnames from "classnames";
import './viewdeal.scss'
//Import Breadcrumb
import {
  digioSignRequest,
  getDealInfo,
  saveDigioResponse,
  digioManualSignRequest,
  digioSignRequestForMou,
  saveDigioResponseMou,
  digioManualSignRequestMoU,
  downloadDealPdf
} from "../../http/fundLync/deal.helper";
import { downloadSystemConfigFile } from "../../http/UAM/systemConfig.helper";
import { callFinancierList } from "http/fundLync/common.helper";
import { dateFormat, decryptedValue, isPermission, uId } from "common/utility";
import {
  callUpdateQuery,
  callGetQueryByEntity,
  callGetFile,
  callDealEsign,
  callAddQuery,
  callDealEsignMou
} from "../../http/fundLync/query.helper";
import InfoDialog from "components/CommonForBoth/TopbarDropdown/InfoDialog";
import { getMeetingByDealAndStatus, getNotes, getShareholdingList, getTaskByDeal, getTaskByDealAndStatus } from "http/fundLync/entityAndAddress.helper";
import TableContainerV1 from "components/Common/TableContainerV1";
import { formatDateString1 } from "pages/EntityDashboard/borrowingProfile";
import { callgetAdditonalDocument } from "http/fundLync/entityDocuments.helper";


//redux
const ViewDeal = (props) => {
  document.title = "Deal | Fundlync";
  const navigate = useNavigate();
  const [entity, setEntity] = useState(null);
  const urlParams = new URLSearchParams(window.location.search);
  const encodedId = urlParams.get("id");
  const decodedId = atob(encodedId);
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [dealInfoList, setDealInfoList] = useState([]);
  const [isQuerySection, setIsQuerySection] = useState(false);
  const [isDocRequired, setIsDocRequired] = useState(false);
  const [queryResponse, setQueryResponse] = useState([]);
  const [queryInfo, setQueryInfo] = useState(null);
  const [propertyInfoList, setPropertyInfoList] = useState([]);
  const [toast, setToast] = useState(false);
  const [count, setCount] = useState(0);
  const [customActiveTab, setCustomActiveTab] = useState("1");
  const [loader, setLoader] = useState(false);
  const [loaderSign, setLoaderSign] = useState(false);
  const user = decryptedValue(localStorage.getItem("user"));
  const [showInfoDialog, setShowInfoDialog] = useState(false);
  const [fields, setFields] = useState([]);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [confirmLoadingMou, setConfirmLoadingMou] = useState(false);
  const [isManualEsign, setIsManualEsign] = useState(false);
  const [isManualEsignMou, setIsManualEsignMou] = useState(false);
  const [templateValues, setTemplateValues] = useState(null);
  const [publicSectorBankList, setPublicSectorBankList] = useState([]);
  const [privateSectorBankList, setPrivateSectorBankList] = useState([]);
  const [nbfcsBankList, setNbfcsBankList] = useState([]);
  const [prefPublicSectorBankList, setPrefublicSectorBankList] = useState([]);
  const [prefPrivateSectorBankList, setPrefPrivateSectorBankList] = useState([]);
  const [prefNbfcsBankList, setprefNbfcsBankList] = useState([]);
  const [selectedisAdditional, setSelectedisAdditional] = useState("");
  const [query, setQuery] = useState(null);
  const [errorSecured, setErrorSecured] = useState("");
  const [isQueryRaised, setIsQueryRaised] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const isRaiseQuery =
  user.entityType == "Owner" || user.entityType == "Partner";
  const [uploadEsignProgress, setUploadEsignProgress] = useState(0);
  const [errorEsignMessage, setErrorEsignMessage] = useState(null);
  const [isQueryRaiseSection, setIsQueryRaiseSection] = useState(false);
  const [selectedTask, setSelectedTask] = useState([]);
  const [selectedMeeting, setSelectedMeeting] = useState([]);
  const [selectedNotes, setSelectedNotes] = useState([]);
  const [taskCount, setTaskCount] = useState('');
  const [meetingCount, setMeetingCount] = useState('');
  const [notesCount, setNotesCount] = useState('');
  const [isTaskApprove, setIsTaskApprove] = useState(false);
  const [isMeetingApprove, setIsMeetingApprove] = useState(false);
  const [isNotesApprove, setIsNotesApprove] = useState(false);
  const [files, setFiles] = useState(null);
  const [isDownloadMandate, setIsDownloadMandate] = useState(false);
  const [dealName,setDealName] = useState()
  const [productNameList,setProductNameList] = useState()
  const [shareholderList, setShareholderList] = useState([])
  const [shareholderSection, setShareholderSection] = useState(false)
  const [shareholdingDate, setShareholdingDate] = useState()
  const [isApprovePermission, setIsApprovePermission] = useState(false);
  const [dealAuthors, setDealAuthors] = useState([])
  const [isAuditLogPermission, setIsAuditLogPermission] = useState(false);
  const [dealDocuments, setDealDocuments] = useState([]);
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      signedDocumentUrl: entity?.signedUser?.signedDocumentUrl || "",
      entityId: entity?.entityId || "",
    },
    validationSchema: Yup.object({
      signedDocumentUrl: Yup.string().required("Please upload file"),
    }),
    onSubmit: (values) => {
      setLoaderSign(true);
      const entity = {
        dealId: decodedId,
        entityId: values.entityId,
        signedDocumentUrl: values.signedDocumentUrl,
      };
      entity.fileName = values.signedDocumentUrl?.substring(
        values.signedDocumentUrl.lastIndexOf("/") + 1
      );
      digioManualSignRequest(entity)
        .then((response) => {
          if (response.code == 201 && response.status) {
            setToastInfo({
              message: response.message,
              showToast: true,
              role: "success",
            });
            // callDealEsign({ id: decodedId, isEsign: 2 })
            //   .then((response) => {
            //     if (response.code == 201 && response.status) {
            //       setLoaderSign(false);
            //       fetchDealInfo();
            //     }
            //   })
            //   .catch((error) => {
            //     setLoaderSign(false);
            //   })
            //   .finally((f) => {
            //     setLoaderSign(false);
            //   });
            setIsManualEsign(false);
          } else {
            setToastInfo({
              message: response.message,
              showToast: true,
              role: "error",
            });
          }
        })
        .catch((error) => {})
        .finally((f) => {});
    },
  });

  const validationForMou = useFormik({
    enableReinitialize: true,
    initialValues: {
      signedDocumentUrl: entity?.signedUserMou?.signedDocumentUrl || "",
      entityId: entity?.entityId || "",
    },
    validationSchema: Yup.object({
      signedDocumentUrl: Yup.string().required("Please upload file"),
    }),
    onSubmit: (values) => {
      setLoaderSign(true);
      const entity = {
        dealId: decodedId,
        entityId: values.entityId,
        signedDocumentUrl: values.signedDocumentUrl,
      };
      entity.fileName = values.signedDocumentUrl?.substring(
        values.signedDocumentUrl.lastIndexOf("/") + 1
      );
      digioManualSignRequestMoU(entity)
        .then((response) => {
          if (response.code == 201 && response.status) {
            setToastInfo({
              message: response.message,
              showToast: true,
              role: "success",
            });
            callDealEsignMou({ id: decodedId, isMouSigned: 1 })
              .then((response) => {
                if (response.code == 201 && response.status) {
                  setLoaderSign(false);
                  fetchDealInfo();
                }
              })
              .catch((error) => {
                setLoaderSign(false);
              })
              .finally((f) => {
                setLoaderSign(false);
              });
            setIsManualEsignMou(false);
          } else {
            setToastInfo({
              message: response.message,
              showToast: true,
              role: "error",
            });
          }
        })
        .catch((error) => {})
        .finally((f) => {});
    },
  });

  const onDropForInput2 = useCallback(async (docType, acceptedFiles) => {
    await createOnDropHandler(acceptedFiles, (result) => {
      setUploadEsignProgress(result.percentage);
      setErrorEsignMessage(result.error);
      validation.setFieldValue(docType, result.file);
    });
  });

  const onDropForInput3 = useCallback(async (docType, acceptedFiles) => {
    await createOnDropHandler(acceptedFiles, (result) => {
      setUploadEsignProgress(result.percentage);
      setErrorEsignMessage(result.error);
      validationForMou.setFieldValue(docType, result.file);
    });
  });

  const updateDigioStatus = async (response) => {
    let respon = response;
    saveDigioResponse(respon)
      .then((response) => {
        fetchDealInfo();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const updateDigioStatusForMou = async (response) => {
    let respon = response;
    saveDigioResponseMou(respon)
      .then((response) => {
        fetchDealInfo();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const checkPermissions = async () => {
    const isTaskAllowed = await isPermission("pending_tasks_tab", "view_permission");
    setIsTaskApprove(isTaskAllowed);
    const isMeetingAllowed = await isPermission("scheduled_meetings_tab", "view_permission");
    setIsMeetingApprove(isMeetingAllowed);
    const isNotesAllowed = await isPermission("notes_tab", "view_permission");
    setIsNotesApprove(isNotesAllowed);
    const isAddNew = await isPermission("download_mandate_copy", "view_permission")
    setIsDownloadMandate(isAddNew)
    const isAddNewApprovePermi = await isPermission("approve_deal", "approve_permission");
    setIsApprovePermission(isAddNewApprovePermi);
    const isAuditLogsPemission = await isPermission("audit_logs", "view_permission");
    setIsAuditLogPermission(isAuditLogsPemission);
  };

  const handleSave = () => {
    setLoaderSign(true)
    const productName = templateValues?.data?.productName;
    const productType = templateValues?.data?.productType;

    let loanType;
    if (
      productName == "Payable Financing" ||
      productName == "Receivable Financing" || productName == "Inventory funding"
    ) {
      loanType =
        "Factoring / Purchase Invoice Discounting / Vendor Financing/ Sales Invoice Discounting/ working Capital limit and any similar product.";
    } else if (productType == "Term loan" || productType == "Others(Lease)") {
      loanType = "Long term loan";
    } else {
      loanType = "";
    }
    setConfirmLoading(true);
    digioSignRequest({
      dealId: decodedId,
      documentSignId: templateValues?.data?.doc_id,
      templateValues: {
        ...templateValues?.data?.templateValue,
      },
    }).then((res1) => {
      if (res1.status) {
        setConfirmLoading(false);
        setShowInfoDialog(false);
        let digioOptions = {
          environment: process.env.REACT_APP_DIGIO_ENV,
          callback: (response) => {
            if (!response?.error_code) {
              // callDealEsign({ id: decodedId, isEsign: 1 })
              //   .then((response) => {
                  // if (response.code == 201 && response.status) {
                    setToastInfo({
                      message: "E-Signed Successfully",
                      showToast: true,
                      role: "success",
                    });
                    validation2.resetForm();
                    setIsQuerySection(!isQuerySection);
                    getQuery();
                    setLoaderSign(false);
                    fetchDealInfo();
                  // } else {
                  //   setToastInfo({
                  //     message: response.message,
                  //     showToast: true,
                  //     role: "error",
                  //   });
                  //   setLoaderSign(false);
                  //   setQueryInfo(null);
                  // }
                // })
                // .catch((error) => {
                //   setLoaderSign(false);
                // })
                // .finally((f) => {
                //   setLoaderSign(false);
                // });
              updateDigioStatus(response);
            }
            setLoaderSign(false);
          },
          logo: "https://cashinvoice.in/wp-content/uploads/2020/03/scroll_logo2.png",
          is_iframe: false,
          theme: {
            primaryColor: "#AB3498",
            secondaryColor: "#000000",
            width: "1000px",
          },
        };
        let digio = new Digio(digioOptions);
        digio.init();
        digio.submit(res1?.data?.id, res1?.data?.signing_parties[0].identifier);
      }
    });
  };

  const handleMOUSignRequest = (prospectiveProduct) => {
    setLoaderSign(true)
    setConfirmLoadingMou(true);
    digioSignRequestForMou({
      dealId: decodedId,
      documentSignId: templateValues?.data?.doc_id,
      prospectiveProduct,
      templateValues: {
        ...templateValues?.data?.templateValue,
      },
    }).then((res1) => {
      if (res1.status) {
        setConfirmLoadingMou(false);
        setShowInfoDialog(false);
        let digioOptions = {
          environment: process.env.REACT_APP_DIGIO_ENV,
          callback: (response) => {
            if (!response?.error_code) {
              callDealEsignMou({ id: decodedId, isMouSigned:1 })
                .then((response) => {
                  if (response.code == 201 && response.status) {
                    setToastInfo({
                      message: "MoU Signed Successfully",
                      showToast: true,
                      role: "success",
                    });
                    validation2.resetForm();
                    setIsQuerySection(!isQuerySection);
                    getQuery();
                    setLoaderSign(false);
                    fetchDealInfo();
                  } else {
                    setToastInfo({
                      message: response.message,
                      showToast: true,
                      role: "error",
                    });
                    setLoaderSign(false);
                    setQueryInfo(null);
                  }
                })
                .catch((error) => {
                  setLoaderSign(false);
                })
                .finally((f) => {
                  setLoaderSign(false);
                });
                updateDigioStatusForMou(response);
            }
            setLoaderSign(false);
          },
          logo: "https://cashinvoice.in/wp-content/uploads/2020/03/scroll_logo2.png",
          is_iframe: false,
          theme: {
            primaryColor: "#AB3498",
            secondaryColor: "#000000",
            width: "1000px",
          },
        };
        let digio = new Digio(digioOptions);
        digio.init();
        digio.submit(res1?.data?.id, res1?.data?.signing_parties[0].identifier);
      }
    });
  };

  const dealEsignManually = () => {
    setLoaderSign(true);
    setLoaderSign(false);
    setIsManualEsign(true);
  };

  const dealEsignManuallyForMou = () => {
    setLoaderSign(true);
    setLoaderSign(false);
    setIsManualEsignMou(true);
  };

  const handleCancelInfo = () => {
    setShowInfoDialog(false);
    setLoaderSign(false);
  };

  const formatDateString = (date) => {
    if (date === null || date === undefined) {
      return null;
    }
    const inputDateString = date;
    const inputDate = new Date(inputDateString);

    const year = inputDate.getFullYear();
    const month = String(inputDate.getMonth() + 1).padStart(2, "0"); // Adding 1 because months are zero-based
    const day = String(inputDate.getDate()).padStart(2, "0");

    const formattedDateString = `${day}-${month}-${year}`;
    return formattedDateString;
  };

  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setCustomActiveTab(tab);
    }
  };

  const dealEsign = () => {
    handleSave()
  };

  const dealEsignForMou = (prospectiveProduct) => {
    handleMOUSignRequest(prospectiveProduct)
  };

  useEffect(() => {
    getQuery();
    fetchDealInfo();
    if (user.entityType == "Owner" || user.entityType == "Partner") {
      setIsAdmin(true)
    }
    checkPermissions()
  }, []);

  const fetchDealInfo = () => {
    getDealInfo({ id: decodedId })
      .then((response) => {
        setEntity(response.data);
        setFiles(response.data?.files);
        setDealName(response.data.dealName)
        callFinancierList()
          .then((res) => {
            const formattedOptions = res?.data.map((option) => ({
              label: option.entityName,
              value: option.id,
              type: option.financierType,
            }));

            const allFinanciers = selectedData(
              formattedOptions,
              response.data?.financier?.join(",")
            );
            const publicSectorBanks = allFinanciers.filter((elem) => {
              return elem.type == "public_sector";
            });
            const privateSectorBanks = allFinanciers.filter((elem) => {
              return elem.type == "private_sector";
            });
            const NBFCsBanks = allFinanciers.filter((elem) => {
              return elem.type == "NBFC";
            });
            setPublicSectorBankList(publicSectorBanks);
            setPrivateSectorBankList(privateSectorBanks);
            setNbfcsBankList(NBFCsBanks);
           
            const allPreferredFinanciers = selectedData(
              formattedOptions,
              response.data?.preferredFinancier?.join(",")
            );
            const preferredPublicSectorBanks = allPreferredFinanciers.filter((elem) => elem.type == 'public_sector');
            const preferredPrivateSectorBanks = allPreferredFinanciers.filter((elem) => elem.type == 'private_sector');
            const preferredNBFCsBanks = allPreferredFinanciers.filter((elem) => elem.type == 'NBFC');
            setPrefublicSectorBankList(preferredPublicSectorBanks)
            setPrefPrivateSectorBankList(preferredPrivateSectorBanks)
            setprefNbfcsBankList(preferredNBFCsBanks)
            
            setDealFields(response.data);
          })
          .catch((error) => {
            console.error(error);
          });
      })
      .catch((error) => {});
  };

  const radioBtnValue = (value) => {
    if(value == null){
      return '-'
    }
    return value ? "Yes" : "No";
  };

  const goBack = () => {
    window.history.back();
  };

  const selectedData = (datalist, data) => {
    const newData = [];
    if (data) {
      const dataValues = data.split(",");

      for (const value of dataValues) {
        const foundItem = datalist.find((item) => item.value == value);
        if (foundItem) {
          newData.push(foundItem);
        }
      }
    }

    return newData;
  };

  const handleAddChange = (event) => {
    if (event.target.value == "Yes") {
      validation.values.isDocRequired = true;
      validation3.setFieldValue("fileList", [{ id: uId(), fileName: "" }]);
      setSelectedisAdditional(event.target.value);
      setErrorSecured("");
    } else {
      validation.values.isDocRequired = false;
      setSelectedisAdditional(event.target.value);
      setSelectedisAdditional(event.target.value);
      setErrorSecured("");
    }
  };

  const validation2 = useFormik({
    enableReinitialize: true,

    initialValues: {
      id: queryInfo?.id || "",
      dealQueryResponse: queryInfo?.dealQueryResponse || "",
      dealQuery: queryInfo?.dealQuery || "",
      isDocRequired: "",
      fileList: [],
    },
    validationSchema: Yup.object({
      dealQueryResponse: Yup.string().required("Please Enter comment"),
      fileList: isDocRequired
        ? Yup.array().of(
            Yup.object({
              fileUpload: Yup.string().required("Please upload file"),
            })
          )
        : Yup.array(),
    }),
    onSubmit: (values) => {
      const entity = {
        id: values.id,
        dealId: decodedId,
        dealQueryResponse: values.dealQueryResponse,
        dealQuery: values.dealQuery,
      };
      if (isDocRequired) {
        entity.isDocRequired = true;
        let newArr = values.fileList.map((ele) => {
          return ele
        })
        entity.fileList = newArr
      } else {
        entity.isDocRequired = false;
      }
      setLoader(true);
      callUpdateQuery(entity)
        .then((response) => {
          if (response.code == 201 && response.status) {
            setToastInfo({
              message: response.message,
              showToast: true,
              role: "success",
            });
            validation2.resetForm();
            setIsQuerySection(!isQuerySection);
            getQuery();
            setLoader(false);
          } else {
            setToastInfo({
              message: response.message,
              showToast: true,
              role: "error",
            });
            setLoader(false);
            setQueryInfo(null);
          }
        })
        .catch((error) => {
          setLoader(false);
        })
        .finally((f) => {
          setLoader(false);
        });
    },
  });

  const validation3 = useFormik({
    enableReinitialize: true,

    initialValues: {
      id: query?.id || "",
      query: query?.query || "",
      isDocRequired: "",
      fileList: [],
    },
    validationSchema: Yup.object({
      query: Yup.string().required("Please Enter comment"),
      fileList:
        selectedisAdditional == "Yes"
          ? Yup.array().of(
              Yup.object({
                fileName: Yup.string().required("File name is required"),
              })
            )
          : Yup.array(),
      isDocRequired:
        selectedisAdditional == ""
          ? Yup.boolean().required("Please Select Option")
          : Yup.boolean(),
    }),
    onSubmit: (values) => {
      const entity = {
        dealId: decodedId,
        dealQuery: values.query,
      };
      if (selectedisAdditional == "Yes") {
        entity.isDocRequired = true;
        let newArr = values.fileList.map((ele) => {
          return ele.fileName;
        });
        entity.fileList = newArr;
      } else {
        entity.isDocRequired = false;
      }
      setLoader(true);
      callAddQuery(entity)
        .then((response) => {
          if (response.code == 201 && response.status) {
            setToastInfo({
              message: response.message,
              showToast: true,
              role: "success",
            });
            setLoader(false);
            validation3.resetForm();
            setIsQueryRaiseSection(!isQueryRaiseSection);
            getQuery();
          } else {
            setToastInfo({
              message: response.message,
              showToast: true,
              role: "error",
            });
            setLoader(false);
          }
        })
        .catch((error) => {
          setLoader(false);
        })
        .finally((f) => {
          setLoader(false);
        });
    },
  });

  const handleCancelClicks = () => {
    validation2.resetForm();
    setQueryInfo(null);
    setQuery(null);
    setIsQuerySection(!isQuerySection);
  };

  const handleCancelRaise = () => {
    validation3.resetForm();
    setIsQueryRaiseSection(!isQueryRaiseSection);
  };

  const getQuery = () => {
    let countQuery = 0;
    callGetQueryByEntity({ dealId: decodedId })
      .then((response) => {
        if (response.code == 200 && response.status) {
          response.data.data.forEach((ele) => {
            setQueryResponse(response.data.data);
            if (!ele.dealQueryResponse) {
              countQuery++;
              setIsQueryRaised(true);
              setToast(true);
            }
            showQueryTimeline(response.data.data);
          });
          setCount(countQuery);
        }
        if (countQuery == 0) {
          setToast(false);
          setIsQueryRaised(false);
        }
      })
      .catch((error) => {});
  };

  const showQueryTimeline = (queryData) => {
    setQueryResponse(queryData);
  };

  const handleDelete = (rowIndex) => {
    validation2.values.fileList.splice(rowIndex, 1);
    validation2.validateForm();
  };

  const handleItemSelect = (data, value) => {
    data.type = value;
    validation2.setFieldValue("type", value);
  };

  const handleReplyQuery = (query) => {
    setQueryInfo(query);
    callGetFile({ queryId: query.id })
      .then((response) => {
        if (response.code == 200 && response.status) {
          let newData = response.data.data.map((ele) => {
            return {
              id: ele.id,
              fileName: ele.fileName,
              fileUpload: ele?.fileUpload || "",
            };
          });
          validation2.setFieldValue("fileList", newData);
          setIsDocRequired(true);
        }
      })
      .catch((error) => {});
    setIsQuerySection(!isQuerySection);
  };


  const convertTo12HourFormat = (time) => {
    let [hours, minutes] = time.split(':');
    hours = parseInt(hours, 10);
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; 
    return `${hours}:${minutes} ${ampm}`;
 };

  useEffect(() => {

    getTaskByDealAndStatus({dealId:decodedId, taskStatus: ['Open', 'In Progress']})
     .then((response)=>{
        const formattedTasks = response.map(task => {
          return {
            ...task,
            dueDate: task.dueDate.split('T')[0],
            dueTime: convertTo12HourFormat(task.dueTime),

          };
        });
        setSelectedTask(formattedTasks);
        setTaskCount(response.length);
     })
     .catch((error)=>{
       console.error(error);
     })

     getMeetingByDealAndStatus({dealId:decodedId,meetingStatus:'Scheduled'})
     .then((response)=>{
      const formattedMeetings = response.map(meeting => {
        return {
          ...meeting,
          date: meeting.date.split('T')[0],
          startTime: convertTo12HourFormat(meeting.startTime),
          endTime: convertTo12HourFormat(meeting.endTime) 
        };
      });
      setSelectedMeeting(formattedMeetings);
      setMeetingCount(response.length);
     })
    .catch((error)=>{
      console.error(error);
    })


    getNotes({dealId:decodedId})
    .then((response)=>{
       setSelectedNotes(response.data.data[0].notes);
       setNotesCount(response.data.data[0].notes.length);
     })
    .catch((error)=>{
      console.error(error);
    })

  },[])

  const handleRaiseQuery = () => {
    setIsQueryRaiseSection(!isQueryRaiseSection);
  };

  const formatDate = (oldDate) => {
    const isoDateString = oldDate;
    const date = new Date(isoDateString);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    };
    const formattedDate = date.toLocaleDateString(undefined, options);

    return formattedDate;
  };

  const handleToast = (info) => {
    setToastInfo(info);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (selectedisAdditional == "") {
      setErrorSecured("Please select an option");
    }
  };
  
  const handleDownload = async (filePath) => {
    try {
      const response = await axios.post(`${API_URL}/downloadFile`, {
        filePath,
      });
      const { result } = response.data;
      const blob = new Blob([Buffer.from(result, "base64")], {
        type: "application/octet-stream",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filePath);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };
  const formatExpectedClosureDate = (dateString) => {
    if (!dateString) return '';
    const date = parse(dateString, 'yyyy-MM', new Date());
    return format(date, 'MMMM, yyyy');
  };
  
  const setDealFields = (data) => {
    const { dealProductCommercials } = data;
    getAllProductsList(dealProductCommercials)
    const commonFields = [
      // { label: "Entity Type", value: data?.dealType },
      // { label: "Entity Name", value: data.entity.entityName },
      // { label: "Counterparty Name", value: data.counterparty?.entityName || "-" },
      { label: "Requested Loan Amount", value: data?.loanRequirement, format: formatNumberWithCommas },
      { label: "Rate of Interest", value: data?.rateOfInterest !== null ? data?.rateOfInterest + "%" : null },
      { label: "Tenure", value: data?.tenure },
      { label: "Loan Type", value: data?.loanType },
      { label: "Guarantee", value: data?.guarantee },
      { label: "Is loan secured?", value: data ? radioBtnValue(data?.isSecured) : null },
      { label: "Security Cover", value: data?.securityCover ? data.securityCover + "X" : null },
      { label: "DealNotes", value: data.dealNotes },
      { label: "Deal Closure Date", value: formatExpectedClosureDate(data?.expectedClosureDate) },
      { label: "Deal Renewal Date", value: formatDateString(data?.renewableDueDate) },
      // { label: "RM", value:  data?.assignedToUser ? `${data.assignedToUser.firstName} ${data.assignedToUser.lastName}` : "-"  },
      // { label: "FI RM", value:  data?.assignedToFirmUser ? `${data.assignedToFirmUser.firstName} ${data.assignedToFirmUser.lastName}` : "-"  },
      // { label: "Program RM", value:  data?.assignedToProgramRmUser ? `${data.assignedToProgramRmUser.firstName} ${data.assignedToProgramRmUser.lastName}` : "-"  },
    ];
  
    const dealInfoList = [...commonFields];
    setDealAuthors([
      { label: "RM", value: data?.assignedToUser ? `${data.assignedToUser.firstName} ${data.assignedToUser.lastName}` : "-" },
      { label: "FI RM", value: data?.assignedToFirmUser ? `${data.assignedToFirmUser.firstName} ${data.assignedToFirmUser.lastName}` : "-" },
      { label: "Program RM", value: data?.assignedToProgramRmUser ? `${data.assignedToProgramRmUser.firstName} ${data.assignedToProgramRmUser.lastName}` : "-" }
    ])
    dealProductCommercials.forEach(dealProduct => {
      const { productType, product } = dealProduct;
      if (productType === "Term loan" && product !== "Infrastructure loan") {
        dealInfoList.push(
          { label: "Selected End Use", value: data?.endUse },
          { label: "Selected Primary Security Type", value: data?.primarySecurity },
          { label: "What is the type of charge?", value: data?.typeOfCharge },
        );
      } else if (product === "Loan against Property") {
        dealInfoList.push(
          { label: "Selected End Use", value: data?.endUse },
          { label: "Selected Bank Name", value: data?.bankName },
          { label: "Is Bank Statement Password Protected?", value: data ? radioBtnValue(data?.isPasswordBankStatement) : null },
          { label: "Entered Bank Statement Password", value: data?.bankStatementPassword },
          { label: "Is there An Income source other Than that declared In the income tax returns that may contribute to the repayment of this loan?", value: data ? radioBtnValue(data?.isOtherIncomeSource) : null },
          { label: "Other Income Amount", value: (data?.otherIncomeAmount || ''), format: formatNumberWithCommas },
          { label: "Is There Co-borrower For This Loan?", value: data ? radioBtnValue(data?.isCoBorrower) : null },
          { label: "Enter Name of The Co-borrower", value: data?.coBorrowerName },
          { label: "D.O.B of The Co-borrower", value: data?.coBorrowerDob, format: formatDateString },
          { label: "Selected Relationship With The Co-borrower", value: data?.coBorrowerRelation },
          { label: "Enter PAN No. of The Co-borrower", value: data?.coBorrowerPanNumber },
          { label: "Income Type of The Co-borrower", value: data?.coBorrowerIncomeType }
        );
        setPropertyInfoList(
          data?.propertyInfo.map((obj) =>
            Object.assign(obj, { id: uId() })
          )
        );
      } else if (product === "Equipment Finance") {
        dealInfoList.push(
          { label: "Selected End Use", value: data?.endUse },
          { label: "Selected Primary Security Type", value: data?.primarySecurity },
          { label: "What is the type of charge?", value: data?.typeOfCharge },
          { label: "Equipment Category", value: data?.equipmentCategory },
          { label: "Equipment Sub-category", value: data?.equipmentSubCategory },
          { label: "Equipment Type", value: data?.equipmentType },
        );
      } else if (product === "Payable Financing" || product === "Forfaiting" || product === "Buyers Credit" || product === "Suppliers Credit") {
        dealInfoList.push(
          { label: "When are vendors currently paid?", value: data?.vendorPay },
          { label: "What is the Business Requirement?", value: data?.businessRequirement },
          { label: "If the lender disburses on Day 1, what cash discount would be received from vendors?", value: data?.vendorDiscount },
          { label: "By how many days would the DPO be extended?", value: data?.extendDpoDays },
          { label: "Is there an existing vendor financing arrangement?", value: data ? radioBtnValue(data?.isVendorArrangement) : null },
          { label: "Selected the entity types with which arrangements have been made", value: data?.vendorsArrangement },
          { label: "Willing to provide any guarantee to the lender?", value: data ? radioBtnValue(data?.isGuaranteeLender) : null },
          { label: "Select the Guarantee type(s)", value: data?.guaranteeTypesLender },
          { label: "What is the value of monthly purchases?", value: data?.monthlyPurchases, format: formatNumberWithCommas }
        );
      } else if (product === "Receivable Financing" || product === 'Inventory funding') {
        dealInfoList.push(
          { label: "Is there a credit period being offered to dealers and distributors?", value: data ? radioBtnValue(data?.isCreditPeriod) : null },
          { label: "What is the average credit period currently offered? (in days)", value: data?.creditPeriod !== 0 ? data?.creditPeriod : null },
          { label: "What is the Business Requirement?", value: data?.businessRequirement },
          { label: "Is there an existing dealer financing arrangement?", value: data ? radioBtnValue(data?.isDealerArrangement) : null },
          { label: "Selected the entity types with which arrangements have been made", value: data?.dealerArrangement },
          { label: "What percentage of dealers are covered by the existing arrangement?", value: data?.percentageCovered ? data?.percentageCovered + '%' : null },
          { label: "Geographically sale North", value: data?.northSales ? data.northSales + "%" : null },
          { label: "Geographically sale South", value: data?.southSales ? data.southSales + "%" : null },
          { label: "Geographically sale East", value: data?.eastSales ? data.eastSales + "%" : null },
          { label: "Geographically sale West", value: data?.westSales ? data.westSales + "%" : null },
          { label: "Is cash discount provided to dealers and distributors?", value: data ? radioBtnValue(data?.isCashDiscount) : null },
          { label: "Would a first loss default guarantee (FLDG) be offered to the lender?", value: data ? radioBtnValue(data?.isFldg) : null },
          { label: "Please mention the maximum percentage of FLDG willing to be provided", value: data?.fldg ? data.fldg + "%" : null },
          { label: "What is the value of monthly sales?", value: data?.monthlySales, format: formatNumberWithCommas }
        );
      } else if (product === "Equity") {
        dealInfoList.push(
          { label: "What % of equity to be diluted?", value: data?.percentageOfEquityDiluted !== null ? data?.percentageOfEquityDiluted + "%" : "-"  },
          { label: "Has the valuation being done?", value: radioBtnValue(data?.isValuationDone) },
          { label: "What kind of investors accepted to the company?", value: data?.investorsType },
          { label: "Whether it is preference share equity or normal equity?", value: data?.equityType },
          { label: "What is the purpose of raising Equity?", value: data?.purposeOfRaisingEquity },
          { label: "Is it fresh equity or diluted?", value: data?.freshOrDiluted },
          { label: "Whose equity is being diluted?", value: data?.dilutedEquityHolder },
        );
        if(data){
          getShareholdingList({ entityId: data?.entityId })
            .then((response) => {
              setShareholderSection(true)
              const allshareholdings = response.data?.data || [];
              if (allshareholdings.length > 0) {
                const formatedDate = formatDateString1(
                  allshareholdings[0].shareholdingAsOf
                );
                allshareholdings[0].shareholdingAsOf = formatedDate;
                setShareholdingDate(response.data?.data[0].shareholdingAsOf)
                setShareholderList(response.data?.data[0].shareholderList)
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } else if (product === "Forfaiting") {
        dealInfoList.push(
          { label: "What is the capex equipment being imported?", value: data?.capexEquipmentImported },
          { label: "which bank will abalize or co-accept the bill of exchange?", value: data?.bankAvalizingBill },
        );
      } else if (product === "Debetures") {
        dealInfoList.push(
          { label: "Whether the debentures are secured or unsecured?", value: data?.debenturesSecuredOrUnsecured },
          { label: "Whether the Debentures are rated or unrated?", value: data?.debenturesRatedOrUnrated },
          { label: "Purpose of issuing Debentures?", value: data?.purposeOfIssuingDebentures },
        );
      } else if (product === "Commercial paper") {
        dealInfoList.push(
          { label: "Purpose of issuing Commercial Paper?", value: data?.purposeOfIssuingCommercial },
          { label: "Whether the Commercial Papers are rated or unrated?", value: data?.commercialRatedOrUnrated },
          { label: "What is the coupon?", value: data?.coupon },
        );
      } else if (product === "Securitisation") {
        dealInfoList.push(
          { label: "Whether the pool is securitise as PSL or non PSL?", value: data?.poolPSLorNonPSL },
          { label: "Whether the pool is rated or unrated?", value: data?.poolRatedOrUnrated },
          { label: "What is the coupon which are looking for?", value: data?.desiredCoupon },
          { label: "What is the ageing of the pool?", value: data?.poolAgeing },
        );
      }
    });
  
    setDealInfoList(dealInfoList);
  }

  const getAllProductsList = (dealProductCommercials) =>{
    let productNameList = []
    dealProductCommercials.map((dealProduct)=>{
      const {product} = dealProduct;
      const { subProduct } = dealProduct;
      const { productType } = dealProduct;
      const { commercials } = dealProduct;

      let obj = {
        product,
        subProduct,
        productType,
        commercials
      }
      productNameList.push(obj)
    })
    setProductNameList(productNameList)
  }

  const checkType = (type, value) => {
    if (type == 'Percentage' || type == 'Throughput' || type == 'NVG') {
      let val = value ? value + '%' : '-'
      return val
    } else {
      let val = value ? '₹' + value : '-'
      return val
    }
  }
  
  const formatLenderName = (name) => {
    if (!name) return '-';
  
    let formattedName = name
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  
    formattedName = formattedName.replace(/\(([^)]+)\)/g, (match, p1) => {
      let transformedContent = p1
        .split(' ')
        .map(word => {
          if (word.toLowerCase() === 'nris') {
            return "NRI's";
          }
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join(' ');
      return `(${transformedContent})`;
    });
  
    return formattedName;
  };
  const formatDateTime = (dateTimeString) => {
    const dateTime = new Date(dateTimeString);
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    return dateTime.toLocaleString("en-US", options);
  };

  const extractFileName = (url) => {
    const segments = url.split('/');
    return decodeURIComponent(segments[segments.length - 1]);
  };

  const editDeal = () => {
    if ((entity?.dealStatus == 3) || ((entity?.dealStatus == 4 || entity?.dealStatus == 2) && isApprovePermission)) {
      const encryptedId = btoa(entity?.id.toString());
      if (user.entityType == "Owner" || user.entityType == "Partner") {
        navigate(`/${user.roleName}/editDeal?id=${encryptedId}`);
      } else {
        navigate(`/customer/editDeal?id=${encryptedId}`);
      }
    }
  };

  const navigateToauditLogs = () => {
    const encryptedId = btoa(entity?.id?.toString());
    navigate(`/${user.roleName}/dealTimeLine?id=${encodeURIComponent(encryptedId)}`);
  };
  const downloadDealDetailsPdf = () => {
    setToastInfo({
      message: 'Downloading please wait...',
      showToast: true,
      role: "success",
    })
    downloadDealPdf({ id: entity?.id }).then((response) => {
      if (response.status) {
        let source = `data:application/pdf;base64,${response.data}`;
        const link = document.createElement("a");
        link.href = source;
        link.download = 'Deal.pdf'
        link.click();
        setToastInfo({
          message: 'Downloaded Successfully',
          showToast: true,
          role: "success",
        })
      } else {
        setToastInfo({
          message: response.message,
          showToast: true,
          role: "error",
        })
      }
    })
  }
  useEffect(() => {
    const fetchDealDocuments = async () => {
      try {
        const response = await callgetAdditonalDocument({ entity_id: entity?.entityId });
        if (response.length > 0) {
          const matchingDocuments = response.filter(doc => doc.dealId === parseInt(decodedId));
    
          if (matchingDocuments.length > 0) {
            setDealDocuments(matchingDocuments);
          } else {
            setDealDocuments([]);
          }
        } else {
          setDealDocuments([]);
        }
      } catch (error) {
        console.error("Error fetching deal documents:", error);
      }
    };
    
  
    fetchDealDocuments();
  }, [entity?.entityId,parseInt(decodedId)]);
  
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="d-flex justify-content-between">
            <div>
              {" "}
              <Breadcrumbs title={`${dealName}`} />
            </div>
            <div style={{ marginTop: "-6px" }}>
              <span
                style={{
                  color: "#21aa47",
                  fontSize: "20px",
                  cursor: "pointer",
                }}
              >
                {isAuditLogPermission && (
                  <i
                    className="fas fa-clipboard-list"
                    id="audit-logs"
                    onClick={() => navigateToauditLogs()}
                  ></i>
                )}
                <i
                  className="fas fa-file-download mx-3"
                  id="download-deal"
                  onClick={() => downloadDealDetailsPdf()}
                ></i>
              </span>
              {isAuditLogPermission && (
                <UncontrolledTooltip placement="top" target="audit-logs">
                  Audit Logs
                </UncontrolledTooltip>
              )}
              <UncontrolledTooltip placement="top" target="download-deal">
                Download Deal
              </UncontrolledTooltip>
            </div>
          </div>
          <Row className="vertical-scroll">
            <Row className="vertical-scroll">
              <Col xs="12">
                {(user.entityType == "Customer" ||
                  (user.entityType == "Owner"
                    ? entity?.assignedTo !== null &&
                      (entity?.assignedTo == user.id ||
                        entity?.createdBy == user.id ||
                        entity?.assignedToFirm == user.id ||
                        entity?.assignedToProgramRm == user.id)
                    : entity?.assignedPartner !== null &&
                      (entity?.assignedPartner == user.id ||
                        entity?.createdBy == user.id))) && (
                  <Nav tabs className="nav-tabs-custom nav-justified mb-4">
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: customActiveTab === "1",
                        })}
                        onClick={() => {
                          toggleCustom("1");
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="fas fa-rupee-sign"></i>
                        </span>
                        <span className="d-none d-sm-block">Deal Details</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: customActiveTab === "2",
                        })}
                        onClick={() => {
                          toggleCustom("2");
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="far fa-question-circle"></i>
                        </span>
                        <span className="d-none d-sm-block">
                          Query (Pending {count})
                        </span>
                      </NavLink>
                    </NavItem>
                    {isTaskApprove && (
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: customActiveTab === "3",
                          })}
                          onClick={() => {
                            toggleCustom("3");
                          }}
                        >
                          <span className="d-block d-sm-none">
                            <i className="fas fa-tasks"></i>
                          </span>
                          <span className="d-none d-sm-block">
                            Tasks(Pending {taskCount})
                          </span>
                        </NavLink>
                      </NavItem>
                    )}
                    {isMeetingApprove && (
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: customActiveTab === "4",
                          })}
                          onClick={() => {
                            toggleCustom("4");
                          }}
                        >
                          <span className="d-block d-sm-none">
                            <i className="fas fa-calendar-alt"></i>
                          </span>
                          <span className="d-none d-sm-block">
                            Meetings(Scheduled {meetingCount})
                          </span>
                        </NavLink>
                      </NavItem>
                    )}
                    {isNotesApprove && (
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: customActiveTab === "5",
                          })}
                          onClick={() => {
                            toggleCustom("5");
                          }}
                        >
                          <span className="d-block d-sm-none">
                            <i className="fas fa-file-alt"></i>
                          </span>
                          <span className="d-none d-sm-block">
                            Notes({notesCount})
                          </span>
                        </NavLink>
                      </NavItem>
                    )}
                  </Nav>
                )}
                <TabContent activeTab={customActiveTab} className=" text-muted">
                  <TabPane tabId="1">
                    <div style={{ padding: "10px" }}>
                      <div className="d-flex justify-content-between mt-1"></div>
                      <div>
                        <Form
                          onSubmit={(e) => {
                            e.preventDefault();
                            return false;
                          }}
                        >
                          <div className="mb-3 row">
                            <Row>
                              <Col sm="12">
                                <div className="d-flex gap-3 justify-content-between">
                                  <h4>Details</h4>
                                  <div className="d-flex gap-3">
                                    <button
                                      className="btn btn-outline-secondary"
                                      type="button"
                                      onClick={goBack}
                                    >
                                      Back
                                    </button>
                                    {(entity?.dealStatus == 3 ||
                                      ((entity?.dealStatus == 4 ||
                                        entity?.dealStatus == 2) &&
                                        isApprovePermission)) && (
                                      <button
                                        className="btn btn-outline-success"
                                        type="button"
                                        onClick={editDeal}
                                      >
                                        Edit
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                            <Col sm="6" md="6">
                              <Label className={`form-label mt-1 mb-1 grey`}>
                                <b>Entity Type</b>
                              </Label>
                              <p style={{ fontSize: "14px" }}>
                                {entity?.dealType || "-"}
                              </p>
                            </Col>
                            <Col sm="6" md="6">
                              <Label className={`form-label mt-1 mb-1 grey`}>
                                <b>Entity Name</b>
                              </Label>
                              <p style={{ fontSize: "14px" }}>
                                {entity?.entity?.entityName || "-"}
                              </p>
                            </Col>
                            {entity?.dealType == "Counterparty" && (
                              <Col sm="6" md="6">
                                <Label className={`form-label mt-1 mb-1 grey`}>
                                  <b>Anchor Name</b>
                                </Label>
                                <p style={{ fontSize: "14px" }}>
                                  {entity?.anchor?.entityName || "-"}
                                </p>
                              </Col>
                            )}
                            {entity?.prospectiveProduct && (
                              <Col sm="6" md="6">
                                <Label className={`form-label mt-1 mb-1 grey`}>
                                  <b>Prospective Product</b>
                                </Label>
                                <p style={{ fontSize: "14px" }}>
                                  {entity?.prospectiveProduct || "-"}
                                </p>
                              </Col>
                            )}
                            {entity?.proposalType && (
                              <Col sm="6" md="6">
                                <Label className={`form-label mt-1 mb-1 grey`}>
                                  <b>Proposal type</b>
                                </Label>
                                <p style={{ fontSize: "14px" }}>
                                  {entity?.proposalType || "-"}
                                </p>
                              </Col>
                            )}
                           {entity?.prospectiveProduct === "TradEasy" && entity?.partnerProgram && (
                              <Col sm="6" md="6">
                                <Label className={`form-label mt-1 mb-1 grey`}>
                                  <b>Partner Program</b>
                                </Label>
                                <p style={{ fontSize: "14px" }}>
                                  {entity?.partnerProgram || "-"}
                                </p>
                              </Col>
                            )}

                            <div
                              style={{
                                margin: "1%",
                                borderTop: "0.5px solid #d7d7d7",
                              }}
                            ></div>

                            {productNameList?.map((field, index) => (
                              <>
                                <div className="mt-2">
                                  <div>
                                    <Row>
                                      <Col key={field.id} sm="6" md="6">
                                        <Label
                                          className={`form-label mt${
                                            index % 2 === 0 ? "2" : "1"
                                          } mb-1 grey`}
                                        >
                                          <b>Product Type</b>
                                        </Label>
                                        <p style={{ fontSize: "14px" }}>
                                          {field.productType || "-"}
                                        </p>
                                      </Col>
                                      <Col key={field.id} sm="6" md="6">
                                        <Label
                                          className={`form-label mt${
                                            index % 2 === 0 ? "2" : "1"
                                          } mb-1 grey`}
                                        >
                                          <b>Product</b>
                                        </Label>
                                        <p style={{ fontSize: "14px" }}>
                                          {field.product || "-"}
                                        </p>
                                      </Col>
                                      {field?.subProduct && (
                                        <Col key={field.id} sm="6" md="6">
                                          <Label
                                            className={`form-label mt${
                                              index % 2 === 0 ? "2" : "1"
                                            } mb-1 grey`}
                                          >
                                            <b>Sub Product</b>
                                          </Label>
                                          <p style={{ fontSize: "14px" }}>
                                            {field.subProduct || "-"}
                                          </p>
                                        </Col>
                                      )}
                                      {/* <div style={{ margin: '1%', borderTop: '0.5px solid #d7d7d7' }}></div> */}
                                    </Row>
                                    <div style={{ marginBottom: "-15px" }}>
                                      <Label className="form-label mt-2 font-size-18 grey">
                                        <p className="font-size-18">
                                          Commercials
                                        </p>
                                      </Label>
                                    </div>
                                    <Row>
                                      <Label
                                        className={`form-label mt${
                                          index % 2 === 0 ? "2" : "1"
                                        } mb-1 font-size-14 text-success`}
                                      >
                                        Platform Charges
                                      </Label>
                                      <Col key={field.id} sm="6" md="3">
                                        <Label
                                          className={`form-label mt${
                                            index % 2 === 0 ? "2" : "1"
                                          } mb-1 grey`}
                                        >
                                          <b>Type</b>
                                        </Label>
                                        <p style={{ fontSize: "14px" }}>
                                          {field.commercials[0]?.platformCharges
                                            ?.Type || "-"}
                                        </p>
                                      </Col>

                                      {field.commercials[0]?.platformCharges
                                        ?.Type == "NVG" && (
                                        <>
                                          <Col key={field.id} sm="6" md="3">
                                            <Label
                                              className={`form-label mt${
                                                index % 2 === 0 ? "2" : "1"
                                              } mb-1 grey`}
                                            >
                                              <b>Benchmark</b>
                                            </Label>
                                            <p style={{ fontSize: "14px" }}>
                                              {field.commercials[0]
                                                ?.platformCharges?.Benchmark ||
                                                "-"}
                                            </p>
                                          </Col>
                                          <Col key={field.id} sm="6" md="3">
                                            <Label
                                              className={`form-label mt${
                                                index % 2 === 0 ? "2" : "1"
                                              } mb-1 grey`}
                                            >
                                              <b>Benchmark Rate (%)</b>
                                            </Label>
                                            <p style={{ fontSize: "14px" }}>
                                              {field.commercials[0]
                                                ?.platformCharges?.BenchmarkRate
                                                ? field.commercials[0]
                                                    ?.platformCharges
                                                    ?.BenchmarkRate + "%"
                                                : "-"}
                                            </p>
                                          </Col>
                                          <Col key={field.id} sm="6" md="3">
                                            <Label
                                              className={`form-label mt${
                                                index % 2 === 0 ? "2" : "1"
                                              } mb-1 grey`}
                                            >
                                              <b>Markup Over Benchmark</b>
                                            </Label>
                                            <p style={{ fontSize: "14px" }}>
                                              {field.commercials[0]
                                                ?.platformCharges
                                                ?.MarkupOverBenchmark
                                                ? field.commercials[0]
                                                    ?.platformCharges
                                                    ?.MarkupOverBenchmark + "%"
                                                : "-"}
                                            </p>
                                          </Col>
                                        </>
                                      )}

                                      <Col key={field.id} sm="6" md="3">
                                        <Label
                                          className={`form-label mt${
                                            index % 2 === 0 ? "2" : "1"
                                          } mb-1 grey`}
                                        >
                                          <b>Frequency</b>
                                        </Label>
                                        <p style={{ fontSize: "14px" }}>
                                          {field.commercials[0]?.platformCharges
                                            ?.Frequency || "-"}
                                        </p>
                                      </Col>
                                      <Col key={field.id} sm="6" md="3">
                                        <Label
                                          className={`form-label mt${
                                            index % 2 === 0 ? "2" : "1"
                                          } mb-1 grey`}
                                        >
                                          <b>Occurrence</b>
                                        </Label>
                                        <p style={{ fontSize: "14px" }}>
                                          {field.commercials[0]?.platformCharges
                                            ?.Occurrence || "-"}
                                        </p>
                                      </Col>
                                      {field.commercials[0]?.platformCharges
                                        ?.Type !== "NVG" && (
                                        <Col key={field.id} sm="6" md="3">
                                          <Label
                                            className={`form-label mt${
                                              index % 2 === 0 ? "2" : "1"
                                            } mb-1 grey`}
                                          >
                                            <b>Value</b>
                                          </Label>
                                          <p style={{ fontSize: "14px" }}>
                                            {checkType(
                                              field.commercials[0]
                                                ?.platformCharges?.Type,
                                              field.commercials[0]
                                                ?.platformCharges?.Value
                                            )}
                                          </p>
                                        </Col>
                                      )}
                                      {field.commercials[0]?.platformCharges
                                        ?.Type == "NVG" && (
                                        <Col key={field.id} sm="6" md="3">
                                          <Label
                                            className={`form-label mt${
                                              index % 2 === 0 ? "2" : "1"
                                            } mb-1 grey`}
                                          >
                                            <b>% of NVG</b>
                                          </Label>
                                          <p style={{ fontSize: "14px" }}>
                                            {checkType(
                                              field.commercials[0]
                                                ?.platformCharges?.Type,
                                              field.commercials[0]
                                                ?.platformCharges?.NVG
                                            )}
                                          </p>
                                        </Col>
                                      )}
                                    </Row>

                                    <Row>
                                      <Label
                                        className={`form-label mt${
                                          index % 2 === 0 ? "2" : "1"
                                        } mb-1 font-size-14 text-success`}
                                      >
                                        {field.product === "Inventory funding"
                                          ? "Gross PF"
                                          : "Syndication Fees"}
                                      </Label>
                                      <Col key={field.id} sm="6" md="3">
                                        <Label
                                          className={`form-label mt${
                                            index % 2 === 0 ? "2" : "1"
                                          } mb-1 grey`}
                                        >
                                          <b>Type</b>
                                        </Label>
                                        <p style={{ fontSize: "14px" }}>
                                          {field.commercials[0]?.syndicationFees
                                            ?.Type || "-"}
                                        </p>
                                      </Col>
                                      <Col key={field.id} sm="6" md="3">
                                        <Label
                                          className={`form-label mt${
                                            index % 2 === 0 ? "2" : "1"
                                          } mb-1 grey`}
                                        >
                                          <b>Frequency</b>
                                        </Label>
                                        <p style={{ fontSize: "14px" }}>
                                          {field.commercials[0]?.syndicationFees
                                            ?.Frequency || "-"}
                                        </p>
                                      </Col>
                                      <Col key={field.id} sm="6" md="3">
                                        <Label
                                          className={`form-label mt${
                                            index % 2 === 0 ? "2" : "1"
                                          } mb-1 grey`}
                                        >
                                          <b>Occurrence</b>
                                        </Label>
                                        <p style={{ fontSize: "14px" }}>
                                          {field.commercials[0]?.syndicationFees
                                            ?.Occurrence || "-"}
                                        </p>
                                      </Col>
                                      <Col key={field.id} sm="6" md="3">
                                        <Label
                                          className={`form-label mt${
                                            index % 2 === 0 ? "2" : "1"
                                          } mb-1 grey`}
                                        >
                                          <b>Value</b>
                                        </Label>
                                        <p style={{ fontSize: "14px" }}>
                                          {checkType(
                                            field.commercials[0]
                                              ?.syndicationFees?.Type,
                                            field.commercials[0]
                                              ?.syndicationFees?.Value
                                          )}
                                        </p>
                                      </Col>
                                    </Row>

                                    <Row>
                                      <Label
                                        className={`form-label mt${
                                          index % 2 === 0 ? "2" : "1"
                                        } mb-1 font-size-14 text-success`}
                                      >
                                        {field.product === "Inventory funding"
                                          ? "Net PF"
                                          : "Integration Fees"}
                                      </Label>
                                      <Col key={field.id} sm="6" md="3">
                                        <Label
                                          className={`form-label mt${
                                            index % 2 === 0 ? "2" : "1"
                                          } mb-1 grey`}
                                        >
                                          <b>Type</b>
                                        </Label>
                                        <p style={{ fontSize: "14px" }}>
                                          {field.commercials[0]?.integrationFees
                                            ?.Type || "-"}
                                        </p>
                                      </Col>
                                      <Col key={field.id} sm="6" md="3">
                                        <Label
                                          className={`form-label mt${
                                            index % 2 === 0 ? "2" : "1"
                                          } mb-1 grey`}
                                        >
                                          <b>Frequency</b>
                                        </Label>
                                        <p style={{ fontSize: "14px" }}>
                                          {field.commercials[0]?.integrationFees
                                            ?.Frequency || "-"}
                                        </p>
                                      </Col>
                                      <Col key={field.id} sm="6" md="3">
                                        <Label
                                          className={`form-label mt${
                                            index % 2 === 0 ? "2" : "1"
                                          } mb-1 grey`}
                                        >
                                          <b>Occurrence</b>
                                        </Label>
                                        <p style={{ fontSize: "14px" }}>
                                          {field.commercials[0]?.integrationFees
                                            ?.Occurrence || "-"}
                                        </p>
                                      </Col>
                                      <Col key={field.id} sm="6" md="3">
                                        <Label
                                          className={`form-label mt${
                                            index % 2 === 0 ? "2" : "1"
                                          } mb-1 grey`}
                                        >
                                          <b>Value</b>
                                        </Label>
                                        <p style={{ fontSize: "14px" }}>
                                          {checkType(
                                            field.commercials[0]
                                              ?.integrationFees?.Type,
                                            field.commercials[0]
                                              ?.integrationFees?.Value
                                          )}
                                        </p>
                                      </Col>
                                    </Row>
                                    <div
                                      style={{
                                        margin: "1%",
                                        borderTop: "0.5px solid #d7d7d7",
                                      }}
                                    ></div>
                                  </div>
                                </div>
                              </>
                            ))}

                            {shareholderSection &&
                              shareholderList?.length !== 0 && (
                                <div
                                  className="mb-4 mt-2"
                                  style={{
                                    padding: "15px 15px 0 25px",
                                    borderRadius: "3px",
                                  }}
                                >
                                  {shareholderList?.length !== 0 ? (
                                    <Row>
                                      <Col sm="6" className="mb-2">
                                        <span className="font-size-14 entityDetailsValue">
                                          <span className="text-success">
                                            Shareholding As Of :{" "}
                                          </span>
                                          {dateFormat(shareholdingDate,"DD-MM-YYYY")}
                                        </span>{" "}
                                      </Col>
                                    </Row>
                                  ) : null}
                                  {shareholderList?.length !== 0 ? (
                                    shareholderList?.map(
                                      (shareholder, index) => (
                                        <React.Fragment key={index}>
                                          <Row className="mt-3">
                                            <Col
                                              sm="6"
                                              md="6"
                                              lg="4"
                                              className="mb-1"
                                            >
                                              <Label className="d-block entityDetails">
                                                Shareholder Name
                                              </Label>
                                              <span className="mb-0 entityDetailsValue">
                                                {shareholder.shareholderName ||
                                                  "-"}
                                              </span>
                                            </Col>
                                            <Col
                                              sm="6"
                                              md="6"
                                              lg="4"
                                              className="mb-1"
                                            >
                                              <Label className="d-block entityDetails">
                                                Shareholder Type
                                              </Label>
                                              <span className="mb-0 entityDetailsValue">
                                                {formatLenderName(
                                                  shareholder.shareholderType
                                                ) || "-"}
                                              </span>
                                            </Col>
                                            <Col
                                              sm="6"
                                              md="6"
                                              lg="4"
                                              className="mb-1"
                                            >
                                              <Label className="d-block entityDetails">
                                                Holding Percentage
                                              </Label>
                                              <span className="mb-0 entityDetailsValue">
                                                {shareholder.percentageHolding !==
                                                  undefined &&
                                                shareholder.percentageHolding !==
                                                  null &&
                                                shareholder.percentageHolding
                                                  ? `${shareholder.percentageHolding}%`
                                                  : "-"}
                                              </span>
                                            </Col>
                                          </Row>

                                          <div
                                            style={{
                                              marginTop: "1%",
                                              borderTop: "0.5px solid #d7d7d7",
                                            }}
                                          ></div>
                                        </React.Fragment>
                                      )
                                    )
                                  ) : (
                                    <div className="mt-5">
                                      <p className="text-center">
                                        No Shareholding records available.
                                      </p>
                                    </div>
                                  )}
                                </div>
                              )}

                            {dealInfoList?.map(
                              (field, index) =>
                                field.value &&
                                field.value !== "-" && (
                                  <Col key={field.id} sm="6" md="6">
                                    <Label
                                      className={`form-label mt${
                                        index % 2 === 0 ? "2" : "1"
                                      } mb-1 grey`}
                                    >
                                      <b>{field.label}</b>
                                    </Label>
                                    <p style={{ fontSize: "14px" }}>
                                      {field.format
                                        ? field.format(field.value)
                                        : field.value || "-"}
                                    </p>
                                  </Col>
                                )
                            )}
                            {entity?.cmaDoc && (
                              <Col sm="6" md="6">
                                <>
                                  <Label className="mt-2 grey">
                                    <b>Download CMA Documents</b>
                                  </Label>

                                  <br />
                                  <i
                                    className="mdi mdi-download"
                                    style={{
                                      fontSize: "25px",
                                      cursor: "pointer",
                                      color: "#34c38f",
                                    }}
                                    onKeyUp={() => {}}
                                    onClick={() => {
                                      formatFunction(
                                        entity?.cmaDoc,
                                        handleToast
                                      );
                                    }}
                                  ></i>
                                </>
                              </Col>
                            )}
                            {entity?.bankStatement && (
                              <Col sm="6" md="6">
                                <>
                                  <Label className="mt-2 mb-1 grey">
                                    <b>Download Bank Statement</b>
                                  </Label>
                                  <br />
                                  <i
                                    className="mdi mdi-download"
                                    style={{
                                      fontSize: "25px",
                                      cursor: "pointer",
                                      color: "#34c38f",
                                    }}
                                    onKeyUp={() => {}}
                                    onClick={() => {
                                      formatFunction(
                                        entity?.bankStatement,
                                        handleToast
                                      );
                                    }}
                                  ></i>
                                </>
                              </Col>
                            )}
                            {entity?.coBorrowerPan && (
                              <Col sm="6" md="6">
                                <>
                                  <Label className="mt-2 mb-1 grey">
                                    <b>Download Co-borrower PAN</b>
                                  </Label>
                                  <br />
                                  <i
                                    className="mdi mdi-download"
                                    style={{
                                      fontSize: "25px",
                                      cursor: "pointer",
                                      color: "#34c38f",
                                    }}
                                    onKeyUp={() => {}}
                                    onClick={() => {
                                      formatFunction(
                                        entity?.coBorrowerPan,
                                        handleToast
                                      );
                                    }}
                                  ></i>
                                </>
                              </Col>
                            )}
                            {files && (
                              <Col sm="6" md="6">
                                <Label className="mt-2 grey">
                                  <b>Download uploaded Documents</b>
                                </Label>
                                {files.map((file, index) => (
                                  <div key={index} className="mb-2">
                                    <b>{file.filename} </b>
                                    {Array.isArray(file.files) &&
                                      file.files.length > 1 && (
                                        <>
                                          {file.files.map(
                                            (innerFile, innerIndex) => (
                                              <b
                                                key={innerIndex}
                                                className="mb-2"
                                              >
                                                <i
                                                  className="mdi mdi-download"
                                                  style={{
                                                    fontSize: "25px",
                                                    cursor: "pointer",
                                                    color: "#34c38f",
                                                  }}
                                                  onClick={() =>
                                                    handleDownload(innerFile)
                                                  }
                                                ></i>
                                              </b>
                                            )
                                          )}
                                        </>
                                      )}
                                    {/* If there's only one file, render the download icon directly */}
                                    {Array.isArray(file.files) &&
                                      file.files.length === 1 && (
                                        <b className="mb-2">
                                          <i
                                            className="mdi mdi-download"
                                            style={{
                                              fontSize: "25px",
                                              cursor: "pointer",
                                              color: "#34c38f",
                                            }}
                                            onClick={() =>
                                              handleDownload(file.files[0])
                                            }
                                          ></i>
                                        </b>
                                      )}
                                  </div>
                                ))}
                              </Col>
                            )}
                            {entity?.coBorrowerItr && (
                              <Col sm="6" md="6">
                                <>
                                  <Label className="mt-2 mb-1 grey">
                                    <b>Download ITR Documents</b>
                                  </Label>
                                  <br />
                                  <i
                                    className="mdi mdi-download"
                                    style={{
                                      fontSize: "25px",
                                      cursor: "pointer",
                                      color: "#34c38f",
                                    }}
                                    onKeyUp={() => {}}
                                    onClick={() => {
                                      formatFunction(
                                        entity?.coBorrowerItr,
                                        handleToast
                                      );
                                    }}
                                  ></i>
                                </>
                              </Col>
                            )}
                            {propertyInfoList?.length > 0 && (
                              <Col sm="12" className="mt-2" lg="12">
                                {propertyInfoList.map((file, index) => (
                                  <TableRow2
                                    key={file.id}
                                    index={index}
                                    validation={propertyInfoList}
                                  />
                                ))}
                              </Col>
                            )}
                            {dealAuthors?.map(
                              (field, index) =>
                                field.value &&
                                field.value !== "-" && (
                                  <Col key={field.id} sm="6" md="6">
                                    <Label
                                      className={`form-label mt${
                                        index % 2 === 0 ? "2" : "1"
                                      } mb-1 grey`}
                                    >
                                      <b>{field.label}</b>
                                    </Label>
                                    <p style={{ fontSize: "14px" }}>
                                      {field.format
                                        ? field.format(field.value)
                                        : field.value || "-"}
                                    </p>
                                  </Col>
                                )
                            )}
                            {(publicSectorBankList?.length > 0 ||
                              privateSectorBankList?.length > 0 ||
                              nbfcsBankList?.length > 0) && isAdmin &&(
                              <Col sm="12" md="12">
                                <Label className="mt-2 grey">
                                  <b>Selected Referred Financier</b>
                                </Label>
                                <br />
                                <Row>
                                  {publicSectorBankList?.length > 0 && (
                                    <Col sm="12" md="6">
                                      <span style={{ fontWeight: "500" }}>
                                        Public Sector Banks
                                      </span>
                                      {publicSectorBankList?.length < 1 && (
                                        <p>-</p>
                                      )}
                                      {publicSectorBankList?.length > 0 && (
                                        <Card
                                          className="vertical-scroll"
                                          style={{ height: "80px" }}
                                        >
                                          <CardBody>
                                            {publicSectorBankList?.map(
                                              (financier, index) => (
                                                <p key={uId()}>
                                                  {index + 1}. {financier.label}
                                                </p>
                                              )
                                            )}
                                          </CardBody>
                                        </Card>
                                      )}
                                    </Col>
                                  )}

                                  {privateSectorBankList?.length > 0 && (
                                    <Col sm="12" md="6">
                                      <span style={{ fontWeight: "500" }}>
                                        Private Sector Banks
                                      </span>
                                      {privateSectorBankList?.length < 1 && (
                                        <p>-</p>
                                      )}
                                      {privateSectorBankList?.length > 0 && (
                                        <Card
                                          className="vertical-scroll"
                                          style={{ height: "80px" }}
                                        >
                                          <CardBody>
                                            {privateSectorBankList?.map(
                                              (financier, index) => (
                                                <p key={uId()}>
                                                  {index + 1}. {financier.label}
                                                </p>
                                              )
                                            )}
                                          </CardBody>
                                        </Card>
                                      )}
                                    </Col>
                                  )}

                                  {nbfcsBankList?.length > 0 && (
                                    <Col sm="12" md="6">
                                      <span style={{ fontWeight: "500" }}>
                                        NBFCs
                                      </span>
                                      {nbfcsBankList?.length < 1 && <p>-</p>}
                                      {nbfcsBankList?.length > 0 && (
                                        <Card
                                          className="vertical-scroll"
                                          style={{ height: "80px" }}
                                        >
                                          <CardBody>
                                            {nbfcsBankList?.map(
                                              (financier, index) => (
                                                <p key={uId()}>
                                                  {index + 1}. {financier.label}
                                                </p>
                                              )
                                            )}
                                          </CardBody>
                                        </Card>
                                      )}
                                    </Col>
                                  )}
                                </Row>
                              </Col>
                            )}

                            {(prefPublicSectorBankList?.length > 0 ||
                              prefPrivateSectorBankList?.length > 0 ||
                              prefNbfcsBankList?.length > 0) && (
                                <Col sm="12" md="12">
                                  <Label className="mt-2 grey">
                                    <b>Selected Preferred Financier</b>
                                  </Label>
                                  <br />
                                  <Row>
                                    {prefPublicSectorBankList?.length > 0 && (
                                      <Col sm="12" md="6">
                                        <span style={{ fontWeight: "500" }}>
                                          Public Sector Banks
                                        </span>
                                        {prefPublicSectorBankList?.length < 1 && (
                                          <p>-</p>
                                        )}
                                        {prefPublicSectorBankList?.length > 0 && (
                                          <Card
                                            className="vertical-scroll"
                                            style={{ height: "80px" }}
                                          >
                                            <CardBody>
                                              {prefPublicSectorBankList?.map(
                                                (preferredFinancier, index) => (
                                                  <p key={uId()}>
                                                    {index + 1}. {preferredFinancier.label}
                                                  </p>
                                                )
                                              )}
                                            </CardBody>
                                          </Card>
                                        )}
                                      </Col>
                                    )}

                                    {prefPrivateSectorBankList?.length > 0 && (
                                      <Col sm="12" md="6">
                                        <span style={{ fontWeight: "500" }}>
                                          Private Sector Banks
                                        </span>
                                        {prefPrivateSectorBankList?.length < 1 && (
                                          <p>-</p>
                                        )}
                                        {prefPrivateSectorBankList?.length > 0 && (
                                          <Card
                                            className="vertical-scroll"
                                            style={{ height: "80px" }}
                                          >
                                            <CardBody>
                                              {prefPrivateSectorBankList?.map(
                                                (preferredFinancier, index) => (
                                                  <p key={uId()}>
                                                    {index + 1}. {preferredFinancier.label}
                                                  </p>
                                                )
                                              )}
                                            </CardBody>
                                          </Card>
                                        )}
                                      </Col>
                                    )}

                                    {prefNbfcsBankList?.length > 0 && (
                                      <Col sm="12" md="6">
                                        <span style={{ fontWeight: "500" }}>
                                          NBFCs
                                        </span>
                                        {prefNbfcsBankList?.length < 1 && <p>-</p>}
                                        {prefNbfcsBankList?.length > 0 && (
                                          <Card
                                            className="vertical-scroll"
                                            style={{ height: "80px" }}
                                          >
                                            <CardBody>
                                              {prefNbfcsBankList?.map(
                                                (preferredFinancier, index) => (
                                                  <p key={uId()}>
                                                    {index + 1}. {preferredFinancier.label}
                                                  </p>
                                                )
                                              )}
                                            </CardBody>
                                          </Card>
                                        )}
                                      </Col>
                                    )}
                                  </Row>
                                </Col>
                              )}


                            {entity?.isEsign != "0" && isDownloadMandate && (
                              <Col sm="6" md="6">
                                <>
                                  <Label className="mt-2 mb-1 grey">
                                    <b>Mandate Letter</b>
                                  </Label>
                                  <br />
                                  <i
                                    className="mdi mdi-download"
                                    style={{
                                      fontSize: "25px",
                                      cursor: "pointer",
                                      color: "#34c38f",
                                    }}
                                    onKeyUp={() => {}}
                                    onClick={() => {
                                      formatFunction(
                                        entity?.signedUser?.signedDocumentUrl,
                                        handleToast
                                      );
                                    }}
                                    title={"Download Mandate Letter"}
                                  ></i>{" "}
                                  {entity?.isEsign == "1"
                                    ? `Signed by ${
                                        entity?.signedUser?.firstName
                                      } ${
                                        entity?.signedUser?.lastName
                                      } on ${dateFormat(
                                        entity?.signedUser?.signedAt,"DD-MM-YYYY"
                                      )}`
                                    : `Uploaded by ${
                                        entity?.signedUser?.firstName
                                      } ${
                                        entity?.signedUser?.lastName
                                      } on ${dateFormat(
                                        entity?.signedUser?.signedAt,"DD-MM-YYYY"
                                      )}`}
                                </>
                              </Col>
                            )}
                            {entity?.isMouSigned != "0" &&
                              isDownloadMandate && (
                                <Col sm="6" md="6">
                                  <>
                                    <Label className="mt-2 mb-1 grey">
                                      <b>MoU Letter</b>
                                    </Label>
                                    <br />
                                    <i
                                      className="mdi mdi-download"
                                      style={{
                                        fontSize: "25px",
                                        cursor: "pointer",
                                        color: "#34c38f",
                                      }}
                                      onKeyUp={() => {}}
                                      onClick={() => {
                                        formatFunction(
                                          entity?.signedUserMou
                                            ?.signedDocumentUrl,
                                          handleToast
                                        );
                                      }}
                                      title={"Download MoU Letter"}
                                    ></i>{" "}
                                    {entity?.isEsign == "1"
                                      ? `Signed by ${
                                          entity?.signedUserMou?.firstName
                                        } ${
                                          entity?.signedUserMou?.lastName
                                        } on ${dateFormat(
                                          entity?.signedUserMou?.signedAt,"DD-MM-YYYY"
                                        )}`
                                      : `Uploaded by ${
                                          entity?.signedUserMou?.firstName
                                        } ${
                                          entity?.signedUserMou?.lastName
                                        } on ${dateFormat(
                                          entity?.signedUserMou?.signedAt,"DD-MM-YYYY"
                                        )}`}
                                  </>
                                </Col>
                              )}
                            {dealDocuments.length !== 0 && (
                              <div className="additional-documents-section">
                                <p
                                  className="mt-4 gray"
                                  style={{ fontSize: "13px", fontWeight: "12", marginBottom: "3px" }}
                                >
                                  Additional Documents
                                </p>
                                  <div
                                    className="row document-header"
                                    style={{
                                      backgroundColor: "#F3F3F3",
                                      borderRadius: "8px",
                                      padding: "5px 5px 5px 0px",
                                      fontSize: "12px",
                                      width: "230px",
                                      border: "1px solid #d7d7d7",
                                       
                                    }}
                                  >
                                    <Col sm="7">
                                      <span>Filename</span>
                                    </Col>
                                    <Col sm="5">
                                      <span>Download</span>
                                    </Col>
                                  </div>

                                  {dealDocuments.map((doc, index) => (
                                    <React.Fragment key={uId()}>
                                      <div
                                        className="row document-row"
                                        style={{
                                          padding: "5px 5px",
                                          borderRadius: "8px",
                                          fontSize: "12px",
                                          width: "250px",
                                        }}
                                      >
                                        <Col
                                          sm="7"
                                          className="d-flex align-items-center"
                                        >
                                          <span>{doc.filename || "-"}</span>
                                        </Col>

                                        <Col
                                          sm="5"
                                          className="d-flex align-items-center"
                                        >
                                          {doc.filePath?.map(
                                            (file, fileIndex) => (
                                              <React.Fragment key={fileIndex}>
                                                <i
                                                  className="mdi mdi-download"
                                                  style={{
                                                    fontSize: "20px",
                                                    cursor: "pointer",
                                                    color: "#34c38f",
                                                    marginRight: "8px",
                                                  }}
                                                  onClick={() =>
                                                    formatFunction(
                                                      file,
                                                      handleToast
                                                    )
                                                  }
                                                  id={`download-tooltip-${index}-${fileIndex}`}
                                                ></i>
                                                <UncontrolledTooltip
                                                  placement="top"
                                                  target={`download-tooltip-${index}-${fileIndex}`}
                                                >
                                                  {extractFileName(file)}
                                                </UncontrolledTooltip>
                                              </React.Fragment>
                                            )
                                          )}
                                        </Col>
                                      </div>

                                      {/* {dealDocuments.length - 1 !== index && (
                                        <div
                                          className="divider"
                                          style={{
                                            margin: "8px 0",
                                            borderTop: "1px solid #d7d7d7",
                                          }}
                                        ></div>
                                      )} */}
                                    </React.Fragment>
                                  ))}
                            </div>)}
                                
                            <div
                              className="divider"
                              style={{
                                margin: "8px 0",
                                borderTop: "1px solid #d7d7d7",
                              }}
                            ></div>
                            <div className="d-sm-flex justify-content-between align-items-center mb-3 note-footer">
                              <p className="mb-0">
                                Created By - {entity?.createdByUser.firstName}{" "}
                                {entity?.createdByUser.lastName}
                              </p>

                              <p className="mb-0">
                                {dateFormat(entity?.createdAt, "DD-MM-YYYY")} |{" "}
                                {entity?.createdAt
                                  ? formatDistanceToNow(
                                      new Date(entity?.createdAt),
                                      {
                                        addSuffix: true,
                                      }
                                    )
                                  : ""}
                              </p>
                            </div>
                            <Row>
                              <Col sm="12">
                                <div className="d-flex flex-column flex-md-row gap-1 justify-content-end">
                                  {entity?.isEsign == "0" &&
                                    entity?.dealStatus == 5 &&
                                    user.entityType == "Customer" &&
                                    entity.mandates[0] &&
                                    entity.mandates[0].userId == user.id && (
                                      <>
                                        <button
                                          className="btn btn-outline-success"
                                          type="button"
                                          onClick={() => {
                                            formatFunction(
                                              entity.mandates[0].mandateFile,
                                              handleToast
                                            );
                                          }}
                                        >
                                          <i
                                            className="mdi mdi-download"
                                            onKeyUp={() => {}}
                                            style={{ fontSize: "14px" }}
                                            onClick={() => {
                                              formatFunction(
                                                entity.mandates[0].mandateFile,
                                                handleToast
                                              );
                                            }}
                                            title={"Download Mandate Letter"}
                                          ></i>
                                          Mandate Letter
                                        </button>
                                        <button
                                          className="btn btn-outline-success"
                                          type="button"
                                          onClick={dealEsign}
                                        >
                                          {confirmLoading && (
                                            <span
                                              className="spinner-border spinner-border-sm ms-2 me-2"
                                              role="status"
                                              aria-hidden="true"
                                            ></span>
                                          )}
                                          {confirmLoading && (
                                            <span>Proceeding</span>
                                          )}
                                          {!confirmLoading && (
                                            <span>Sign Mandate</span>
                                          )}
                                        </button>
                                      </>
                                    )}
                                  {entity?.isMouSigned == "0" &&
                                    (entity.prospectiveProduct == "TradEasy" ||
                                      entity.prospectiveProduct ==
                                        "PayEarly") &&
                                    user.entityType == "Customer" &&
                                    entity.mouDetails[0] &&
                                    entity.mouDetails[0].userId == user.id && (
                                      <>
                                        <button
                                          className="btn btn-outline-success"
                                          type="button"
                                          onClick={() => {
                                            formatFunction(
                                              entity.mouDetails[0].mouFile,
                                              handleToast
                                            );
                                          }}
                                        >
                                          <i
                                            className="mdi mdi-download"
                                            onKeyUp={() => {}}
                                            style={{ fontSize: "14px" }}
                                            onClick={() => {
                                              formatFunction(
                                                entity.mouDetails[0].mouFile,
                                                handleToast
                                              );
                                            }}
                                            title={"Download MoU Letter"}
                                          ></i>
                                          MoU Letter
                                        </button>
                                        <button
                                          className="btn btn-outline-success"
                                          type="button"
                                          onClick={() => {
                                            dealEsignForMou(
                                              entity.prospectiveProduct
                                            );
                                          }}
                                        >
                                          {confirmLoadingMou && (
                                            <span
                                              className="spinner-border spinner-border-sm ms-2 me-2"
                                              role="status"
                                              aria-hidden="true"
                                            ></span>
                                          )}
                                          {confirmLoadingMou && (
                                            <span>Proceeding</span>
                                          )}
                                          {!confirmLoadingMou && (
                                            <span>Sign MoU</span>
                                          )}
                                        </button>
                                      </>
                                    )}
                                </div>

                                <div className="d-flex flex-column flex-md-row gap-1 justify-content-end">
                                  {entity?.isEsign == "0" &&
                                    entity?.dealStatus == 5 &&
                                    ((user.entityType == "Owner" &&
                                      (user.id == entity?.assignedTo ||
                                        entity?.createdBy == user.id)) ||
                                      user.id == entity?.assignedToFirm ||
                                      user.id == entity?.assignedToProgramRm ||
                                      (user.entityType == "Partner" &&
                                        (entity?.assignedPartner == user.id ||
                                          entity?.createdBy == user.id))) && (
                                      <button
                                        className="btn btn-outline-success"
                                        type="button"
                                        onClick={dealEsignManually}
                                      >
                                        <i
                                          className="bx bx-file-blank"
                                          onKeyUp={() => {}}
                                          style={{ fontSize: "14px" }}
                                          title={"Upload Signed Document"}
                                        ></i>
                                        Upload Signed Document
                                      </button>
                                    )}
                                  {entity?.isMouSigned == "0" &&
                                    ((user.entityType == "Owner" &&
                                      (entity?.prospectiveProduct ==
                                        "TradEasy" ||
                                        entity?.prospectiveProduct ==
                                          "PayEarly") &&
                                      (user.id == entity?.assignedTo ||
                                        entity?.createdBy == user.id ||
                                        user.id == entity?.assignedToFirm ||
                                        user.id ==
                                          entity?.assignedToProgramRm)) ||
                                      (user.entityType == "Partner" &&
                                        (entity?.assignedPartner == user.id ||
                                          entity?.createdBy == user.id))) && (
                                      <button
                                        className="btn btn-outline-success"
                                        type="button"
                                        onClick={dealEsignManuallyForMou}
                                      >
                                        <i
                                          className="bx bx-file-blank"
                                          onKeyUp={() => {}}
                                          style={{ fontSize: "14px" }}
                                          title={"Upload MoU Document"}
                                        ></i>
                                        Upload MoU Document
                                      </button>
                                    )}
                                </div>
                              </Col>
                            </Row>
                            <Row></Row>
                          </div>
                        </Form>
                      </div>
                    </div>
                  </TabPane>

                  {(user.entityType == "Customer" ||
                    (user.entityType == "Owner"
                      ? entity?.assignedTo !== null &&
                        (entity?.assignedTo == user.id ||
                          entity?.createdBy == user.id ||
                          entity?.assignedToFirm == user.id ||
                          entity?.assignedToProgramRm == user.id)
                      : entity?.assignedPartner !== null &&
                        (entity?.assignedPartner == user.id ||
                          entity?.createdBy == user.id))) && (
                    <TabPane tabId="2">
                      <div style={{ padding: "10px" }}>
                        <div className="d-flex justify-content-between mt-1">
                          {queryResponse.length > 0 && (
                            <div>
                              <h5>Query</h5>
                            </div>
                          )}
                        </div>

                        <div>
                          <Row>
                            <Col sm="12">
                              {!isQueryRaised && isRaiseQuery && (
                                <div className="d-flex gap-3 justify-content-start mb-3">
                                  <button
                                    className="btn btn-outline-primary"
                                    type="button"
                                    onClick={handleRaiseQuery}
                                  >
                                    Raise Query
                                  </button>
                                </div>
                              )}
                              <div>
                                <ul className="verti-timeline list-unstyled">
                                  {queryResponse.length > 0 &&
                                    !isQueryRaiseSection &&
                                    queryResponse.map((query, index) => (
                                      <li key={query.id} className="event-list">
                                        <div className="event-timeline-dot">
                                          <i className="bx bx-right-arrow-circle" />
                                        </div>
                                        <div>
                                          <Card className="flex-grow-1">
                                            <CardBody
                                              style={{
                                                backgroundColor:
                                                  "rgb(249,251,252)",
                                              }}
                                            >
                                              {query.dealQueryResponse && (
                                                <div className="d-flex ">
                                                  <Col lg="11">
                                                    <span className="text-secondary">
                                                      Reply:{" "}
                                                    </span>
                                                    <span className="text-muted font-size-14">
                                                      <span className="text-success">
                                                        "
                                                        {
                                                          query.dealQueryResponse
                                                        }
                                                        ".
                                                      </span>{" "}
                                                      <br />
                                                      <span className="text-secondary font-size-12 ms-4">
                                                        (by{" "}
                                                        {
                                                          query.updatedByUser
                                                            ?.first_name
                                                        }{" "}
                                                        {
                                                          query.updatedByUser
                                                            ?.last_name
                                                        }{" "}
                                                        from{" "}
                                                        <span className="text-warning">
                                                          {
                                                            query.deal.entity
                                                              .entity_name
                                                          }
                                                        </span>
                                                        ,{" "}
                                                        {dateFormat(
                                                          query.updatedAt,"DD-MM-YYYY"
                                                        )}
                                                        )
                                                      </span>
                                                    </span>
                                                    <br />
                                                    {query.isDocRequired && (
                                                      <div className="ms-4">
                                                        {query.fileUploads?.map(
                                                          (ele) => (
                                                            <div
                                                              key={ele.id}
                                                              className="d-flex gap-1"
                                                              onKeyUp={() => {}}
                                                              onClick={() => {
                                                                formatFunction(
                                                                  ele?.file_upload,
                                                                  handleToast
                                                                );
                                                              }}
                                                            >
                                                              <span>
                                                                {ele.file_name}
                                                              </span>
                                                              <i
                                                                className="mdi mdi-download font-size-16 text-success"
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                              ></i>
                                                            </div>
                                                          )
                                                        )}
                                                      </div>
                                                    )}
                                                  </Col>
                                                </div>
                                              )}

                                              {!query.dealQueryResponse &&
                                                (user.entityType == "Owner"
                                                  ? entity?.assignedTo ==
                                                      user.id ||
                                                    entity?.createdBy ==
                                                      user.id ||
                                                    entity?.assignedToFirm ==
                                                      user.id ||
                                                    entity?.assignedToProgramRm ==
                                                      user.id
                                                  : true) && (
                                                  <div className="d-flex gap-3 justify-content-start mb-3">
                                                    <span
                                                      className="text-success"
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      onKeyUp={() => {}}
                                                      onClick={(e) =>
                                                        handleReplyQuery(query)
                                                      }
                                                    >
                                                      Reply to Query
                                                    </span>
                                                  </div>
                                                )}

                                              {isQuerySection &&
                                                query.id == queryInfo.id && (
                                                  <FormikProvider
                                                    value={validation2}
                                                  >
                                                    <Form
                                                      onSubmit={(e) => {
                                                        e.preventDefault();
                                                        validation2.handleSubmit();
                                                        return false;
                                                      }}
                                                    >
                                                      <Row className="mb-3 row">
                                                        <Col sm="12" md="6">
                                                          <Label className="form-label mt-4">
                                                            Comment*
                                                          </Label>
                                                          <Input
                                                            name="dealQueryResponse"
                                                            type="textarea"
                                                            placeholder="Add Comment"
                                                            onChange={
                                                              validation2.handleChange
                                                            }
                                                            onBlur={
                                                              validation2.handleBlur
                                                            }
                                                            value={
                                                              validation2.values
                                                                .dealQueryResponse ||
                                                              ""
                                                            }
                                                            invalid={
                                                              !!(
                                                                validation2
                                                                  .touched
                                                                  .dealQueryResponse &&
                                                                validation2
                                                                  .errors
                                                                  .dealQueryResponse
                                                              )
                                                            }
                                                          />
                                                          {validation2.touched
                                                            .dealQueryResponse &&
                                                          validation2.errors
                                                            .dealQueryResponse ? (
                                                            <FormFeedback type="invalid">
                                                              {
                                                                validation2
                                                                  .errors
                                                                  .dealQueryResponse
                                                              }
                                                            </FormFeedback>
                                                          ) : null}
                                                        </Col>
                                                        {query.isDocRequired && (
                                                          <Col
                                                            sm="12"
                                                            className="mt-2"
                                                          >
                                                            <FieldArray
                                                              name="fileList"
                                                              render={(
                                                                arrayHelpers
                                                              ) => (
                                                                <>
                                                                  {validation2.values.fileList.map(
                                                                    (
                                                                      file,
                                                                      index
                                                                    ) => (
                                                                      <TableRow
                                                                        key={
                                                                          file.id
                                                                        }
                                                                        onDelete={
                                                                          handleDelete
                                                                        }
                                                                        onItemSelect={
                                                                          handleItemSelect
                                                                        }
                                                                        index={
                                                                          index
                                                                        }
                                                                        validation={
                                                                          validation2
                                                                        }
                                                                      />
                                                                    )
                                                                  )}
                                                                </>
                                                              )}
                                                            />
                                                          </Col>
                                                        )}
                                                      </Row>

                                                      <Row>
                                                        <Col>
                                                          <div className="d-flex gap-3 justify-content-end">
                                                            <button
                                                              type="button"
                                                              className="btn btn-outline-secondary"
                                                              onClick={
                                                                handleCancelClicks
                                                              }
                                                            >
                                                              Cancel
                                                            </button>
                                                            <button
                                                              type="submit"
                                                              className="btn btn-success save-customer"
                                                            >
                                                              Save
                                                            </button>
                                                          </div>
                                                        </Col>
                                                      </Row>
                                                    </Form>
                                                  </FormikProvider>
                                                )}

                                              <br />

                                              <div>
                                                <Col lg="11">
                                                  <span className="text-secondary">
                                                    Query:{" "}
                                                  </span>
                                                  <span className="text-muted font-size-14">
                                                    <span className="text-primary">
                                                      "{query.dealQuery}".
                                                    </span>{" "}
                                                    <br />
                                                    {query.isDocRequired && (
                                                      <div className="ms-4">
                                                        {query.fileUploads?.map(
                                                          (ele) => (
                                                            <ul key={ele.id}>
                                                              <li>
                                                                {ele.file_name}{" "}
                                                              </li>
                                                            </ul>
                                                          )
                                                        )}
                                                      </div>
                                                    )}
                                                    <span className="text-secondary font-size-12 ms-4">
                                                      (by{" "}
                                                      {query.user?.first_name}{" "}
                                                      {query.user?.last_name}{" "}
                                                      from{" "}
                                                      <span className="text-warning">
                                                        {
                                                          query.entity
                                                            .entityName
                                                        }
                                                      </span>
                                                      ,{" "}
                                                      {dateFormat(
                                                        query.updatedAt,"DD-MM-YYYY"
                                                      )}
                                                      )
                                                    </span>
                                                  </span>
                                                  <br />
                                                </Col>
                                              </div>
                                            </CardBody>
                                          </Card>
                                        </div>
                                      </li>
                                    ))}
                                </ul>
                                {isQueryRaiseSection &&
                                  isRaiseQuery &&
                                  !isQueryRaised && (
                                    <FormikProvider value={validation3}>
                                      <Form
                                        className="mb-4"
                                        onSubmit={(e) => {
                                          e.preventDefault();
                                          handleSubmit(e);
                                          validation3.handleSubmit();
                                          return false;
                                        }}
                                      >
                                        <Row className="mb-3 row">
                                          <Col sm="12" md="6">
                                            <Label className="form-label mt-4">
                                              Comment*
                                            </Label>
                                            <Input
                                              name="query"
                                              type="textarea"
                                              placeholder="Add Comment"
                                              onChange={
                                                validation3.handleChange
                                              }
                                              onBlur={validation3.handleBlur}
                                              value={
                                                validation3.values.query || ""
                                              }
                                              invalid={
                                                !!(
                                                  validation3.touched.query &&
                                                  validation3.errors.query
                                                )
                                              }
                                            />
                                            {validation3.touched.query &&
                                            validation3.errors.query ? (
                                              <FormFeedback type="invalid">
                                                {validation3.errors.query}
                                              </FormFeedback>
                                            ) : null}
                                          </Col>
                                          <Col sm="12" md="7">
                                            <Label className="form-label mt-4">
                                              Is Additional documents required?*
                                            </Label>
                                            <div className="d-flex ms-4">
                                              <div>
                                                <Input
                                                  type="radio"
                                                  id="isAdditional1"
                                                  value="Yes"
                                                  onChange={() => {}}
                                                  style={{
                                                    border: "1px solid black",
                                                  }}
                                                  checked={
                                                    selectedisAdditional ==
                                                    "Yes"
                                                  }
                                                  onClick={handleAddChange}
                                                />
                                                <Label
                                                  htmlFor="isAdditional1"
                                                  className="ms-2"
                                                >
                                                  Yes
                                                </Label>
                                              </div>
                                              <div className="ms-4">
                                                <Input
                                                  type="radio"
                                                  id="isAdditional2"
                                                  onChange={() => {}}
                                                  value="No"
                                                  style={{
                                                    border: "1px solid black",
                                                  }}
                                                  checked={
                                                    selectedisAdditional == "No"
                                                  }
                                                  onClick={handleAddChange}
                                                />
                                                <Label
                                                  htmlFor="isAdditional2"
                                                  className="ms-2"
                                                >
                                                  No
                                                </Label>
                                              </div>
                                            </div>
                                            {errorSecured && (
                                              <p
                                                style={{
                                                  color: "rgb(245,116,116)",
                                                  fontSize: "11px",
                                                }}
                                                className="ms-4"
                                              >
                                                {errorSecured}
                                              </p>
                                            )}
                                          </Col>
                                          {selectedisAdditional == "Yes" && (
                                            <Col sm="12" className="mt-2">
                                              <table>
                                                <thead>
                                                  <tr>
                                                    <td
                                                      style={{
                                                        fontWeight: "500",
                                                      }}
                                                    >
                                                      Enter Document Name
                                                    </td>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  <FieldArray
                                                    name="fileList"
                                                    render={(arrayHelpers) => (
                                                      <>
                                                        {validation3.values.fileList.map(
                                                          (file, index) => (
                                                            <TableRow3
                                                              key={file.id}
                                                              onDelete={
                                                                handleDelete
                                                              }
                                                              onItemSelect={
                                                                handleItemSelect
                                                              }
                                                              index={index}
                                                              validation={
                                                                validation3
                                                              }
                                                            />
                                                          )
                                                        )}
                                                        <span
                                                          className="text-success"
                                                          style={{
                                                            cursor: "pointer",
                                                          }}
                                                          onKeyUp={() => {}}
                                                          onClick={() => {
                                                            arrayHelpers.push({
                                                              fileName: "",
                                                            });
                                                          }}
                                                        >
                                                          <i className="mdi mdi-plus me-1" />{" "}
                                                          Add File
                                                        </span>
                                                      </>
                                                    )}
                                                  />
                                                </tbody>
                                              </table>
                                            </Col>
                                          )}
                                        </Row>

                                        <Row>
                                          <Col>
                                            <div className="d-flex gap-3 justify-content-end">
                                              <button
                                                type="button"
                                                className="btn btn-outline-secondary"
                                                onClick={handleCancelRaise}
                                              >
                                                Cancel
                                              </button>
                                              <button
                                                type="submit"
                                                className="btn btn-success save-customer"
                                              >
                                                Save
                                              </button>
                                            </div>
                                          </Col>
                                        </Row>
                                      </Form>
                                    </FormikProvider>
                                  )}
                              </div>
                            </Col>
                            {queryResponse.length == 0 &&
                              !isQueryRaiseSection && (
                                <Col>
                                  <div className="font-size-18 text-center">
                                    No query found
                                  </div>
                                </Col>
                              )}
                          </Row>
                        </div>
                      </div>
                    </TabPane>
                  )}

                  <TabPane tabId="3">
                    <div style={{ padding: "10px" }}>
                      <div className="d-flex justify-content-between mt-1"></div>
                      <div>
                        <div className="table-responsive">
                          <Table className="table table-bordered mb-0">
                            <thead className="table-light">
                              <tr>
                                <th scope="col">ID</th>
                                <th scope="col">Task Name</th>
                                <th scope="col">Task Status</th>
                                <th scope="col">Task Type</th>
                                <th scope="col">Task Priority</th>
                                <th scope="col">Due Date</th>
                                <th scope="col">Due Time</th>
                              </tr>
                            </thead>
                            <tbody>
                              {selectedTask.length == 0 ? (
                                <tr>
                                  <td colSpan={12} className="text-center">
                                    No data found
                                  </td>
                                </tr>
                              ) : (
                                selectedTask.map((item, index) => (
                                  <tr key={item.id}>
                                    <td
                                      className={`${
                                        index % 2 == 0
                                          ? "table-row-odd"
                                          : "table-row-even"
                                      }`}
                                    >
                                      {item.id}
                                    </td>
                                    <td
                                      className={`${
                                        index % 2 == 0
                                          ? "table-row-odd"
                                          : "table-row-even"
                                      }`}
                                    >
                                      {item.taskName}
                                    </td>
                                    <td
                                      className={`${
                                        index % 2 == 0
                                          ? "table-row-odd"
                                          : "table-row-even"
                                      }`}
                                    >
                                      {item.taskStatus}
                                    </td>
                                    <td
                                      className={`${
                                        index % 2 == 0
                                          ? "table-row-odd"
                                          : "table-row-even"
                                      }`}
                                    >
                                      {item.taskType}
                                    </td>
                                    <td
                                      className={`${
                                        index % 2 == 0
                                          ? "table-row-odd"
                                          : "table-row-even"
                                      }`}
                                    >
                                      {item.taskPriority}
                                    </td>
                                    <td
                                      className={`${
                                        index % 2 == 0
                                          ? "table-row-odd"
                                          : "table-row-even"
                                      }`}
                                    >
                                      {dateFormat(item.dueDate,"DD-MM-YYYY")}
                                    </td>
                                    <td
                                      className={`${
                                        index % 2 == 0
                                          ? "table-row-odd"
                                          : "table-row-even"
                                      }`}
                                    >
                                      {item.dueTime}
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                  </TabPane>

                  <TabPane tabId="4">
                    <div style={{ padding: "10px" }}>
                      <div className="d-flex justify-content-between mt-1"></div>
                      <div>
                        <div className="table-responsive">
                          <Table className="table table-bordered mb-0">
                            <thead className="table-light">
                              <tr>
                                <th scope="col">ID</th>
                                <th scope="col">Title</th>
                                <th scope="col">Meeting Status</th>
                                <th scope="col">Date</th>
                                <th scope="col">Start Time</th>
                                <th scope="col">End Time</th>
                                <th scope="col">Medium</th>
                              </tr>
                            </thead>
                            <tbody>
                              {selectedMeeting.length == 0 ? (
                                <tr>
                                  <td colSpan={12} className="text-center">
                                    No data found
                                  </td>
                                </tr>
                              ) : (
                                selectedMeeting.map((item, index) => (
                                  <tr key={item.id}>
                                    <td
                                      className={`${
                                        index % 2 == 0
                                          ? "table-row-odd"
                                          : "table-row-even"
                                      }`}
                                    >
                                      {item.id}
                                    </td>
                                    <td
                                      className={`${
                                        index % 2 == 0
                                          ? "table-row-odd"
                                          : "table-row-even"
                                      }`}
                                    >
                                      {item.title}
                                    </td>
                                    <td
                                      className={`${
                                        index % 2 == 0
                                          ? "table-row-odd"
                                          : "table-row-even"
                                      }`}
                                    >
                                      {item.meetingStatus}
                                    </td>
                                    <td
                                      className={`${
                                        index % 2 == 0
                                          ? "table-row-odd"
                                          : "table-row-even"
                                      }`}
                                    >
                                      {dateFormat(item.date,"DD-MM-YYYY")}
                                    </td>
                                    <td
                                      className={`${
                                        index % 2 == 0
                                          ? "table-row-odd"
                                          : "table-row-even"
                                      }`}
                                    >
                                      {item.startTime}
                                    </td>
                                    <td
                                      className={`${
                                        index % 2 == 0
                                          ? "table-row-odd"
                                          : "table-row-even"
                                      }`}
                                    >
                                      {item.endTime}
                                    </td>
                                    <td
                                      className={`${
                                        index % 2 == 0
                                          ? "table-row-odd"
                                          : "table-row-even"
                                      }`}
                                    >
                                      {item.medium}
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                  </TabPane>

                  <TabPane tabId="5">
                    <div style={{ padding: "10px" }}>
                      <div className="d-flex justify-content-between mt-1"></div>
                      <div>
                        <div className="table-responsive">
                          <Table className="table table-bordered mb-0">
                            <thead className="table-light">
                              <tr>
                                <th scope="col">ID</th>
                                <th scope="col">Notes Description</th>
                                <th scope="col">Uploaded Documents</th>
                              </tr>
                            </thead>
                            <tbody>
                              {selectedNotes.length == 0 ? (
                                <tr>
                                  <td colSpan={12} className="text-center">
                                    No data found
                                  </td>
                                </tr>
                              ) : (
                                selectedNotes.map((item, index) => (
                                  <tr key={item.id}>
                                    <td
                                      className={`${
                                        index % 2 == 0
                                          ? "table-row-odd"
                                          : "table-row-even"
                                      }`}
                                    >
                                      {item.id}
                                    </td>
                                    <td
                                      className={`${
                                        index % 2 == 0
                                          ? "table-row-odd"
                                          : "table-row-even"
                                      }`}
                                    >
                                      {item.notes}
                                    </td>
                                    <td
                                      className={`${
                                        index % 2 == 0
                                          ? "table-row-odd"
                                          : "table-row-even"
                                      }`}
                                    >
                                      {item?.additionalDocuments[0]?.file_path?.map(
                                        (file, fileIndex) => (
                                          <span
                                            key={`file-${item.id}-${index}`}
                                            style={{ marginRight: "10px" }}
                                          >
                                            <i
                                              className="mdi mdi-download"
                                              style={{
                                                fontSize: "25px",
                                                cursor: "pointer",
                                                color: "#34c38f",
                                              }}
                                              onClick={() => {
                                                formatFunction(
                                                  file,
                                                  handleToast
                                                );
                                              }}
                                              id={`download-icon-${item.id}-${fileIndex}`}
                                            ></i>
                                            <UncontrolledTooltip
                                              placement="top"
                                              target={`download-icon-${item.id}-${fileIndex}`}
                                            >
                                              {extractFileName(file)}
                                            </UncontrolledTooltip>
                                          </span>
                                        )
                                      )}
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                  </TabPane>
                </TabContent>
              </Col>
            </Row>
          </Row>
        </Container>
      </div>
      {(user.entityType == "Customer" ||
        (user.entityType == "Owner"
          ? entity?.assignedTo !== null &&
            (entity?.assignedTo == user.id ||
              entity?.createdBy == user.id ||
              entity?.assignedToFirm == user.id ||
              entity?.assignedToProgramRm == user.id)
          : entity?.assignedPartner !== null &&
            (entity?.assignedPartner == user.id ||
              entity?.createdBy == user.id))) && (
        <div
          className="position-fixed top-0 end-0 p-3"
          style={{ zIndex: "1005" }}
        >
          {toast && (
            <UncontrolledAlert
              color="warning"
              className="alert-dismissible fade show"
              role="alert"
            >
              {count === 1
                ? "You have 1 query awaiting your response."
                : `You have ${count} queries awaiting your response.`}
            </UncontrolledAlert>
          )}
        </div>
      )}
      <InfoDialog
        isShow={showInfoDialog}
        headerInfo="Please review your information before proceeding with E-signature"
        fields={fields}
        onSave={handleSave}
        onCancel={handleCancelInfo}
        confirmLoading={confirmLoading}
      />
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
      <Loader show={loaderSign} type="box" message="E-Signing" />
      <Loader show={loader} type="box" message="Replying to Query" />

      <Modal
        isOpen={isManualEsign}
        role="dialog"
        autoFocus={true}
        centered
        data-toggle="modal"
        toggle={() => {
          setIsManualEsign(!isManualEsign);
        }}
      >
        <div>
          <ModalHeader
            className="border-bottom-0"
            toggle={() => {
              setIsManualEsign(!isManualEsign);
            }}
          ></ModalHeader>
        </div>
        <div className="modal-body">
          <div className="text-center mb-4">
            <div className="row justify-content-center">
              <div className="col-xl-10">
                <h4 className="text-success">Upload Signed Document</h4>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  <Row>
                    <Col sm="12" md="12">
                      <DynamicFileUploadInput
                        inputName={`signedDocumentUrl`}
                        onDropHandler={(acceptedFiles) =>
                          onDropForInput2(`signedDocumentUrl`, acceptedFiles)
                        }
                        isDragActive={true}
                        validation={validation}
                        uploadProgress={uploadEsignProgress}
                        errorMessage={errorEsignMessage}
                      />
                    </Col>
                    <Col sm="12">
                      <div className="d-flex gap-3 justify-content-end  mt-4">
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={() => {
                            validation.setFieldValue("signedDocumentUrl", "");
                            setIsManualEsign(!isManualEsign);
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-success save-customer"
                        >
                          Upload
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={isManualEsignMou}
        role="dialog"
        autoFocus={true}
        centered
        data-toggle="modal"
        toggle={() => {
          setIsManualEsignMou(!isManualEsignMou);
        }}
      >
        <div>
          <ModalHeader
            className="border-bottom-0"
            toggle={() => {
              setIsManualEsignMou(!isManualEsignMou);
            }}
          ></ModalHeader>
        </div>
        <div className="modal-body">
          <div className="text-center mb-4">
            <div className="row justify-content-center">
              <div className="col-xl-10">
                <h4 className="text-success">Upload Signed MoU</h4>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validationForMou.handleSubmit();
                    return false;
                  }}
                >
                  <Row>
                    <Col sm="12" md="12">
                      <DynamicFileUploadInput
                        inputName={`signedDocumentUrl`}
                        onDropHandler={(acceptedFiles) =>
                          onDropForInput3(`signedDocumentUrl`, acceptedFiles)
                        }
                        isDragActive={true}
                        validation={validationForMou}
                        uploadProgress={uploadEsignProgress}
                        errorMessage={errorEsignMessage}
                      />
                    </Col>
                    <Col sm="12">
                      <div className="d-flex gap-3 justify-content-end  mt-4">
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={() => {
                            validationForMou.setFieldValue(
                              "signedDocumentUrl",
                              ""
                            );
                            setIsManualEsignMou(!isManualEsignMou);
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-success save-customer"
                        >
                          Upload
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default withRouter(ViewDeal);

ViewDeal.propTypes = {
  history: PropTypes.object,
};

function downloadFile(base64String, ext, fileName) {
  let source = "";
  if (ext == "zip") {
    source = `data:application/zip;base64,${base64String}`;
    const link = document.createElement("a");
    link.href = source;
    link.download = fileName;
    link.click();
  } else {
    source = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64String}`;
    const link = document.createElement("a");
    link.href = source;
    link.download = fileName;
    link.click();
  }
}

const TableRow = ({ index, validation }) => {
  const [uploadProgress, setUploadProgress] = useState(0);
  const [errorMessage, setErrorMessage] = useState(null);

  const onDropForInput1 = useCallback(async (docType, acceptedFiles) => {
    await createOnDropHandler(acceptedFiles, (result) => {
      setUploadProgress(result.percentage);
      setErrorMessage(result.error);
      validation.setFieldValue(`fileList.${index}.${docType}`, result.file);
    });
  });

  return (
    <Col sm="12" md="6">
      <DynamicFileUploadInputForTableRow
        label={validation.values.fileList[index].fileName}
        inputName={`file[${index}].name`}
        onDropHandler={(acceptedFiles) => onDropForInput1(`fileUpload`, acceptedFiles)}
        isDragActive={true}
        validation={validation}
        uploadProgress={uploadProgress}
        errorMessage={errorMessage}
        index={index}
      />
    </Col>
  );
};

const TableRow2 = ({ index, validation }) => {
  const [toastInfo, setToastInfo] = useState({ showToast: false });

  const handleToast = (info) => {
    setToastInfo(info);
  };

  return (
    <div className="mt-4">
      <div>
        <h5 className="form-label mt-3 text-success">Property: {index + 1}</h5>
        <Row>

          <Col sm="12" md="6">
            <Label className="form-label mt-1 mb-1 grey">
              <b>Select Nature Of Property</b>
            </Label>
            <p>{validation[index].propertyNature || '-'}</p>
          </Col>

          <Col sm="12" md="6">
            <Label className="form-label mt-1 mb-1 grey">
              <b>Owner of the property</b>
            </Label>
            <p>{validation[index].propertyOwner || '-'}</p>
          </Col>

          <Col sm="12" md="6">
            <Label className="form-label mt-1 mb-1 grey">
              <b>Select Status of the property</b>
            </Label>
            <p>{validation[index].propertyStatus || '-'}</p>
          </Col>

          <Col sm="12" md="6">
            <Label className="form-label mt-1 mb-1 grey">
              <b>Approximate value of the property</b>
            </Label>
            <p>{formatNumberWithCommas(validation[index].propertyValue) || '-'}</p>
          </Col>

          <Col sm="12" md="6">
            <Label className="form-label mt-1 mb-1 grey">
              <b>Property Age (Years)</b>
            </Label>
            <p>{validation[index].propertyAge || '-'}</p>
          </Col>

          <Col sm="12" md="6">
            <Label className="form-label mt-1 mb-1 grey">
              <b>Enter Property Address</b>
            </Label>
            <p>{validation[index].address || '-'}</p>
          </Col>

          <Col sm="12" md="6">
            <Label className="form-label mt-1 mb-1 grey">
              <b>Enter Property Pincode</b>
            </Label>
            <p>{validation[index].pincode || '-'}</p>
          </Col>

          <Col sm="12" md="6">
            <Label className="form-label mt-1 mb-1 grey">
              <b>City</b>
            </Label>
            <p>{validation[index].city || '-'}</p>
          </Col>

          <Col sm="12" md="6">
            <Label className="form-label mt-1 mb-1 grey">
              <b>Selected State</b>
            </Label>
            <p>{validation[index].state || '-'}</p>
          </Col>

          {validation[index].parentDeed && (<Col sm="12" md="6">
            <Label className="mt-1 mb-1 grey">
              <b>Download Parent Deed</b>
            </Label>
            <br />
            <i
              className="mdi mdi-download"
              style={{ fontSize: "25px", cursor: "pointer", color: "#34c38f" }}
              onKeyUp={() => { }}
              onClick={() => {
                formatFunction(validation[index].parentDeed, handleToast);
              }}
            />
          </Col>)}

          {validation[index].saleDeed && (<Col sm="12" md="6">
            <Label className="mt-1 mb-1 grey">
              <b>Download Sale Deed</b>
            </Label>
            <br />
            <i
              className="mdi mdi-download"
              style={{ fontSize: "25px", cursor: "pointer", color: "#34c38f" }}
              onKeyUp={() => { }}
              onClick={() => {
                formatFunction(validation[index].saleDeed, handleToast);
              }}
            />
          </Col>)}

         {validation[index].utilityBills && ( <Col sm="12" md="6">
            <Label className="mt-1 mb-1 grey">
              <b>Download Utility Bills</b>
            </Label>
            <br />
            <i
              className="mdi mdi-download"
              style={{ fontSize: "25px", cursor: "pointer", color: "#34c38f" }}
              onKeyUp={() => { }}
              onClick={() => {
                formatFunction(validation[index].utilityBills, handleToast);
              }}
            />
          </Col>)}

          {validation[index].propertyTax && (<Col sm="12" md="6">
            <Label className="mt-1 mb-1 grey">
              <b>Download Property Tax</b>
            </Label>
            <br />
            <i
              className="mdi mdi-download"
              style={{ fontSize: "25px", cursor: "pointer", color: "#34c38f" }}
              onKeyUp={() => { }}
              onClick={() => {
                formatFunction(validation[index].propertyTax, handleToast);
              }}
            />
          </Col>)}
        </Row>

      </div>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </div>
  );
};

function formatFunction(file, showToastCallback) {
  
  const str = file.substring(file.indexOf("com") + 4);
  const filename = file.substring(file.lastIndexOf("/") + 1);
  const ext = str.split(".").pop();
  const obj = {
    fileName: str,
  };

  downloadSystemConfigFile(obj)
    .then((response) => {
      if (response.code === 200) {
        downloadFile(response.result, ext, filename);
        showToastCallback({
          message: "Downloaded successfully",
          showToast: true,
          role: "success",
        });
      } else {
        showToastCallback({
          message: response.message,
          showToast: true,
          role: "error",
        });
      }
    })
    .catch((error) => {});
}

const formatNumberWithCommas = (number) => {
  if (number) {
    const formattedNumber = number.toString().replace(/\./, ",");
    const parts = formattedNumber.split(",");
    if (parts[0].length > 3) {
      const lastThree = parts[0].substr(parts[0].length - 3);
      const remaining = parts[0].slice(0, parts[0].length - 3);
      parts[0] =
        remaining.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
    }

    return "₹" + " " + parts.join(".");
  }
};

const DynamicFileUploadInputForTableRow = ({
  label,
  inputName,
  onDropHandler,
  validation,
  uploadProgress,
  errorMessage,
  index,
}) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: onDropHandler,
  });

  const fileName = (filename) => {
    return filename?.substring(filename.lastIndexOf("/") + 1);
  };

  const handleLabelClick = (event) => {
    event.stopPropagation();
    document.getElementById(inputName).click();
  };

  return (
    <div>
      <Label
        htmlFor={inputName}
        className="col-sm-6 col-form-label mt-3"
      >
        {label}*
      </Label>
      <div
        style={{
          display: "table",
          width: "100%",
          backgroundColor: "#fff",
          border: "dotted 2px #21aa47",
          borderRadius: "5px",
        }}
      >
        <div {...getRootProps()} className="text-wrapper">
          <div className="centered">
            <Input
              type="file"
              name={inputName}
              id={inputName}
              accept=".jpg, .png, .jpeg, .pdf, .xlsx, .xls"
              {...getInputProps({
                onClick: (event) => {
                  event.stopPropagation();
                },
              })}
              style={{ display: 'none' }} // Hide the actual file input
            />
            <label
              style={{
                marginBottom: 0,
                fontSize: "14px",
                cursor: "pointer",
              }}
              onClick={handleLabelClick} // Custom click handler for label
            >
              <img
                src="https://scfuat.cashinvoice.in/frontend/assets/themes/image/icon/cloud.png"
                className="img-fluid"
                style={{ width: "30px" }}
                alt="Upload"
              />
              {isDragActive && <p className="textLink">Drop here</p>}
              <span
                className="textLink"
                style={{ padding: "5px" }}
              >
                Browse files to attach
              </span>{" "}
              or Drop
            </label>
          </div>
        </div>
      </div>
      {validation.touched.fileList?.[index]?.["fileUpload"] &&
        validation.errors.fileList?.[index]?.["fileUpload"] && (
          <p className="text-danger font-size-11">
            {validation.errors.fileList[index]?.["fileUpload"]}
          </p>
        )}
      <span className="mt-2">
        {fileName(validation.values.fileList[index]?.["fileUpload"])}{" "}
      </span>
      {uploadProgress > 0 && !errorMessage && (
        <div className="progress mt-4">
          <div
            className="progress-bar bg-success"
            style={{ width: `${uploadProgress}%` }}
            aria-valuenow={uploadProgress}
            aria-valuemin="0"
            aria-valuemax="100"
          >
            {`${uploadProgress}%`}
          </div>
        </div>
      )}
      {errorMessage && (
        <div className="alert alert-danger mt-4">{errorMessage}</div>
      )}
    </div>
  );
};

const createOnDropHandler = async (acceptedFiles, cb) => {
  if (acceptedFiles[0]) {
    cb({ percentage: 0 });
    let formData = new FormData();
    formData.append("upl", acceptedFiles[0]);
    const config = {
      onUploadProgress: (progressEvent) => {
        const percentage = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        cb({ percentage });
      },
    };
    try {
      const response = await axios.post(
        `${API_URL}/s3/uploadSystemConfigFiles`,
        formData,
        config
      );
      if (response.status === 200) {
        cb({ file: response.data[0].fileName });
      } else {
        cb({ error: response.data.message });
      }
    } catch (error) {
      cb({ error: error.response.data.message });
    }
  }
};

const DynamicFileUploadInput = ({
  label,
  inputName,
  onDropHandler,
  validation,
  uploadProgress,
  errorMessage,
}) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: onDropHandler,
  });

  const fileName = (filename) => {
    return filename?.substring(filename.lastIndexOf("/") + 1);
  };

  const handleLabelClick = (event) => {
    event.stopPropagation();
    document.getElementById(inputName).click();
  };

  return (
    <div>
      <Label
        htmlFor={inputName}
        className="col-sm-6 col-form-label mt-3"
      >
        {label}
      </Label>
      <div
        style={{
          display: "table",
          width: "100%",
          backgroundColor: "#fff",
          border: "dotted 2px #21aa47",
          borderRadius: "5px",
        }}
      >
        <div
          {...getRootProps()}
          className="text-wrapper"
          style={{ height: "70px" }}
        >
          <div className="centered">
            <Input
              type="file"
              name={inputName}
              id={inputName}
              accept=".jpg, .png, .jpeg, .pdf, .xlsx, .xls"
              {...getInputProps({
                onClick: (event) => {
                  event.stopPropagation();
                },
              })}
              style={{ display: 'none' }} // Hide the actual file input
            />
            <label
              style={{
                marginBottom: 0,
                fontSize: "14px",
                cursor: "pointer",
              }}
              onClick={handleLabelClick}
            >
              <img
                src="https://scfuat.cashinvoice.in/frontend/assets/themes/image/icon/cloud.png"
                className="img-fluid"
                alt="Upload"
              />
              {isDragActive && <p className="textLink">Drop here</p>}
              <span className="textLink" style={{ cursor: "pointer", padding: "5px" }}>Browse files to attach</span>
              {''}
              or Drop
            </label>
          </div>
        </div>
      </div>
      {validation.touched[inputName] && validation.errors[inputName] && (
        <p className="text-danger font-size-11">
          {validation.errors[inputName]}
        </p>
      )}
      <span className="mt-2">{fileName(validation.values[inputName])}</span>
      {uploadProgress > 0 && !errorMessage && (
        <div className="progress mt-4">
          <div
            className="progress-bar bg-success"
            style={{ width: `${uploadProgress}%` }}
            aria-valuenow={uploadProgress}
            aria-valuemin="0"
            aria-valuemax="100"
          >
            {`${uploadProgress}%`}
          </div>
        </div>
      )}
      {errorMessage && (
        <div className="alert alert-danger mt-4">{errorMessage}</div>
      )}
    </div>
  );
};

const TableRow3 = ({ onDelete, index, validation }) => {
  const handleInputChange = (index, field, value) => {
    validation.setFieldValue(`fileList.${index}.${field}`, value);
  };

  return (
    <tr>
      <td style={{ padding: "10px" }}>
        <Input
          type="text"
          placeholder="Enter file Name"
          name={`file[${index}].name`}
          id={`file[${index}].name`}
          value={validation.values.fileList[index].fileName}
          onChange={(e) => handleInputChange(index, "fileName", e.target.value)}
          invalid={
            !!(
              validation.touched.fileList?.[index]?.fileName &&
              validation.errors.fileList?.[index]?.fileName
            )
          }
        />
        {validation.touched.fileList?.[index]?.fileName &&
          validation.errors.fileList?.[index]?.fileName && (
            <FormFeedback>
              {validation.errors.fileList[index].fileName}
            </FormFeedback>
          )}
      </td>
      <td>
        {validation.values?.fileList?.length > 1 && (
          <i
            className="bx bx-x-circle text-danger"
            onKeyUp={() => {}}
            onClick={() => onDelete(index)}
            style={{ cursor: "pointer", fontSize: "17px" }}
          />
        )}
      </td>
    </tr>
  );
};
